/**
 * Thai copy — a first-class, fully-translated SELECTABLE language (switcher in AppShell), not the app
 * default (English is the default; see i18n/index.ts). Natural + professional staff-tool register —
 * concise, no marketing fluff. Every user-facing string lives here under a stable key; components never
 * hardcode copy.
 */
const th = {
  app: {
    name: "ZPCD Portal",
    tagline: "ระบบติดตามลูกค้า Zoom สำหรับทีมงาน",
  },

  nav: {
    primary: "เมนูหลัก",
    home: "หน้าแรก",
    dashboard: "งานที่ต้องดูแล",
    customers: "ลูกค้า",
    search: "ค้นหา",
    settings: "ตั้งค่า",
    users: "ผู้ใช้งาน",
    audit: "บันทึกการใช้งาน",
    pool: "Online Channel",
  },

  // Short month names for usage tables + report chart axes (keyed 1..12). Never hardcode English.
  months: {
    short: {
      "1": "ม.ค.",
      "2": "ก.พ.",
      "3": "มี.ค.",
      "4": "เม.ย.",
      "5": "พ.ค.",
      "6": "มิ.ย.",
      "7": "ก.ค.",
      "8": "ส.ค.",
      "9": "ก.ย.",
      "10": "ต.ค.",
      "11": "พ.ย.",
      "12": "ธ.ค.",
    },
  },

  // Short weekday names for the Insights report's weekly-rhythm chart (ISO weekday, 1=Mon..7=Sun).
  weekdays: {
    short: {
      "1": "จ.",
      "2": "อ.",
      "3": "พ.",
      "4": "พฤ.",
      "5": "ศ.",
      "6": "ส.",
      "7": "อา.",
    },
  },

  action: {
    search: "ค้นหา",
    open: "เปิดดู",
    close: "ปิด",
    cancel: "ยกเลิก",
    confirm: "ยืนยัน",
    back: "ย้อนกลับ",
    retry: "ลองอีกครั้ง",
    save: "บันทึก",
    syncNow: "ดึงข้อมูลสดตอนนี้",
    syncPlansUsage: "ดึงข้อมูลแพ็กเกจ/การใช้งานสด",
    syncUsers: "ดึงรายชื่อผู้ใช้สด",
    syncAccounts: "ดึงรายการบัญชีสด",
    copyId: "คัดลอกรหัส",
    sortAsc: "เรียงจากน้อยไปมาก",
    sortDesc: "เรียงจากมากไปน้อย",
  },

  shell: {
    omniboxPlaceholder: "ค้นหาอีเมล ชื่อบัญชี เลขบัญชี เจ้าของ หรือเลขใบแจ้งหนี้",
    openOmnibox: "เปิดช่องค้นหา",
    openMenu: "เปิดเมนู",
    closeMenu: "ปิดเมนู",
    userMenu: "เมนูผู้ใช้",
    signOut: "ออกจากระบบ",
    language: "ภาษา",
    skipToContent: "ข้ามไปยังเนื้อหา",
  },

  lang: {
    th: "ไทย",
    en: "English",
    switchTo: "เปลี่ยนเป็น {{lang}}",
  },

  role: {
    owner: "เจ้าของระบบ",
    admin: "ผู้ดูแลระบบ",
    viewer: "ผู้ดูข้อมูล",
    custom: "สิทธิ์กำหนดเอง",
  },

  // The FOUR freshness labels — never mixed (design §6.2).
  freshness: {
    // (1) per-feed mirror data age — from ZPCD's sync marker.
    mirror: "ข้อมูล Zoom ณ {{time}}",
    mirrorNightly: "ข้อมูล Zoom ณ {{time}} (sync รายคืน)",
    // (2) mirror-health — is the poller keeping the mirror current (a different question).
    mirrorHealthOk: "ระบบ sync ข้อมูลเป็นปัจจุบัน",
    mirrorHealthStale: "ระบบ sync ข้อมูลล่าช้า",
    mirrorHealthChecked: "ตรวจสอบเมื่อ {{time}}",
    // (3) sync-now live fetch — ONLY from a sync-now ok response.
    live: "ดึงสดเมื่อ {{time}}",
    unknown: "ไม่ทราบเวลา",
    // (4) worklist matview refresh — a DIFFERENT fact from mirror/mirror-health/live. Amber variant fires
    // when the server says the refresh is stale/errored (never let a paused refresh read as live).
    worklist: "รายการงาน ณ {{time}}",
    worklistStale: "รายการงานอาจไม่เป็นปัจจุบัน — ณ {{time}}",
  },

  // Utilization band labels — keyed on the five canonical band codes (display.tsx UTIL_BANDS).
  utilizationBand: {
    high: "ใช้งานสูง",
    healthy: "ใช้งานเหมาะสม",
    low: "ใช้งานน้อย",
    very_low: "ใช้งานน้อยมาก",
    unknown: "ไม่ทราบ",
  },

  customer: {
    title: "ข้อมูลลูกค้า",
    plan: "แพ็กเกจ",
    // สถานะของ "แพลน" (ไม่ใช่ account_status ของ Zoom ซึ่งยังขึ้น active อยู่แม้แพลนจะตายไปนานแล้ว)
    planStatus: "สถานะแพลน",
    seats: "จำนวนสิทธิ์",
    owner: "เจ้าของบัญชี",
    account: "บัญชี",
    accountName: "ชื่อบัญชี",
    accountType: "ประเภทบัญชี",
    accountNumber: "เลขบัญชี",
    status: "สถานะ",
    renewal: "วันต่ออายุ",
    daysUntilRenewal: "อีก {{days}} วัน",
    utilization: "อัตราการใช้งาน",
    meetings30d: "การประชุม 30 วัน",
    tier: {
      label: "tier: {{tier}}",
      unknown: "ไม่ทราบ tier",
    },
    tabs: {
      overview: "ภาพรวม",
      subscription: "แพ็กเกจ",
      usage: "การใช้งาน",
      users: "ผู้ใช้",
      reports: "รายงาน",
      invoice: "ใบแจ้งหนี้",
    },
    subscription: {
      basePlan: "แพ็กเกจหลัก",
      addons: "แพ็กเกจ",
      addon: "ส่วนเสริม",
      type: "ประเภท",
      hosts: "จำนวนสิทธิ์",
      planName: "ชื่อแพ็กเกจ",
      quantity: "จำนวน",
      billingPeriod: "รอบบิล",
      licenses: "{{qty}} สิทธิ์",
      licenseOne: "{{qty}} สิทธิ์",
      licenseMany: "{{qty}} สิทธิ์",
      roomOne: "{{qty}} ห้อง",
      roomMany: "{{qty}} ห้อง",
      portOne: "{{qty}} พอร์ต",
      portMany: "{{qty}} พอร์ต",
      details: "รายละเอียด",
      effective: "เริ่มมีผล",
      nextInvoice: "รอบบิลถัดไป",
      noAddons: "ไม่มีแพ็กเกจ",
      noAddonsBody: "บัญชีนี้ยังไม่มีแพ็กเกจ",
      billing: "การเรียกเก็บ",
      bundled: "รวมในแพ็กเกจ",
      paid: "ซื้อแยก",
      tierUnknown: "ไม่ทราบ tier",
      expiresOn: "(หมดอายุ {{date}})",
      freePlanTitle: "You are currently on a Basic Plan (Free)",
      freePlanBody: "Basic Plan never expires. This account has no paid subscription.",
    },
    usage: {
      recordingStorage: "พื้นที่บันทึกการประชุม",
      planUsage: "การใช้งานตามแพ็กเกจ",
      plan: "แพ็กเกจ",
      assigned: "ใช้ไป",
      capacity: "สิทธิ์ทั้งหมด",
      usedStorage: "พื้นที่ที่ใช้",
      planStorage: "พื้นที่ตามแพ็กเกจ",
      unlimited: "ไม่จำกัด",
      noPlanUsage: "ไม่มีข้อมูลการใช้งานตามแพ็กเกจ",
      noStorage: "ไม่มีข้อมูลพื้นที่บันทึก",
      idleSeats: "ว่าง {{count}}",
      fullyUsed: "ใช้ครบ",
      payg: "คิดตามใช้จริง",
      // คำตัดสินของ owner 18/9/2026 (N0-3): Zoom ตอบ 403/2031 ตอนขอข้อมูลโทรศัพท์ของบัญชีนี้
      phoneNotEnabled: "บัญชีนี้ยังไม่ได้เปิดใช้งาน Zoom Phone",
    },
    phone: {
      calls: "สาย",
      totalCalls: "สายทั้งหมด",
      direction: "เข้า / ออก",
      inboundOutbound: "สายเข้า / สายออก",
      talkTime: "เวลาคุยรวม",
      min: "นาที",
      approxHours: "≈ {{hours}} ชั่วโมง",
      activeDays: "{{count}} วันที่มีสาย",
      inbound: "สายเข้า",
      outbound: "สายออก",
    },
    users: {
      email: "อีเมล",
      type: "ประเภท",
      firstName: "ชื่อ",
      lastName: "นามสกุล",
      license: "License",
      role: "บทบาท",
      lastLogin: "เข้าใช้ล่าสุด",
      roleOwner: "Owner",
      roleAdmin: "Admin",
      roleMember: "Member",
      roleCustom: "Custom",
      licenseBasic: "Zoom Meetings Basic",
      licenseNone: "ไม่มี",
      licensePhone: "Zoom Phone",
      licenseWebinar: "Zoom Webinars",
      licenseLargeMeeting: "Large Meeting",
      typeBasic: "Basic",
      typeLicensed: "Licensed",
      typeOnPrem: "On-Prem",
      typeOther: "อื่นๆ",
      filterPlaceholder: "กรองตามชื่อ อีเมล หรือบทบาท",
      filterByLicense: "License:",
      clearLicenseFilter: "ล้าง",
      rosterCadenceNote:
        "รายชื่อผู้ใช้จาก Zoom อัปเดตเป็นรอบตามกำหนด รายการนี้จึงอาจช้ากว่าบัญชีจริงสองสามวัน — กด Sync now หากต้องการข้อมูลล่าสุด",
      count: "แสดง {{shown}} จาก {{total}} คน",
      fromSearch: "จากการค้นหา",
      noMatch: "ไม่พบผู้ใช้ที่ตรงกับคำค้น",
      noMatchBody: "ไม่พบผู้ใช้ที่ตรงกับ “{{term}}”",
      tabUsers: "ผู้ใช้ ({{total}})",
      tabPending: "รอตอบรับ ({{count}})",
      tabPendingNotLoaded: "รอตอบรับ",
      subTabsLabel: "ผู้ใช้และผู้ได้รับคำเชิญที่รอตอบรับ",
      pendingNote:
        "ได้รับคำเชิญแล้วแต่ยังไม่ตอบรับ — ยังเป็นผู้ใช้ของบัญชีปัจจุบันจนกว่าจะตอบรับคำเชิญ",
      invited: "เชิญเมื่อ",
      noPending: "ไม่มีคำเชิญที่รอตอบรับ",
      noPendingBody: "ไม่มีคำเชิญที่รอตอบรับในข้อมูลรายชื่อล่าสุด",
      filterPendingPlaceholder: "กรองตามอีเมล",
      noPendingMatch: "ไม่พบคำเชิญที่ตรงกับคำค้น",
      noPendingMatchBody: "ไม่พบคำเชิญที่รอตอบรับที่ตรงกับ “{{term}}”",
      pendingNotLoaded: "ยังไม่ได้โหลดรายการคำเชิญที่รอตอบรับ",
      pendingNotLoadedBody: "รายการจะแสดงหลังการซิงก์รายชื่อผู้ใช้รอบกลางคืนครั้งถัดไป",
      truncatedNote:
        "แสดง {{returned}} คนแรก (จากทั้งหมด {{total}}) ตัวเลขด้านบนนับครบทุกคน ตารางจำกัดจำนวนเพื่อ performance",
    },
    reports: {
      print: "พิมพ์ / PDF",
      period: "ช่วงเวลา",
      generate: "สร้างรายงาน",
      choosePrompt: "เลือกช่วงเวลา",
      chooseBody: "เลือกช่วงวันที่ + ประเภท แล้วกด สร้างรายงาน",
      from: "ตั้งแต่",
      to: "ถึง",
      type: "ประเภท",
      typeBoth: "การประชุมและเว็บบินาร์",
      typeMeetings: "การประชุม",
      typeWebinars: "เว็บบินาร์",
      kpiEvents: "การประชุมและเว็บบินาร์",
      kpiMeetings: "การประชุม",
      kpiWebinars: "เว็บบินาร์",
      kpiParticipants: "ผู้เข้าร่วม",
      kpiMinutes: "นาที",
      approxHours: "≈ {{hours}} ชั่วโมง",
      trendEvents: "{{unit}} ต่อช่วงเวลา",
      trendParticipants: "ผู้เข้าร่วมต่อช่วงเวลา",
      trendMinutes: "นาทีต่อช่วงเวลา",
      kpiActiveHosts: "Active hosts",
      activeHostsHint: "จำนวน host ไม่ซ้ำตลอดทั้งช่วง — ไม่ใช่ผลรวมของแท่งกราฟ",
      trendActiveHosts: "Active hosts ต่อช่วงเวลา",
      activeHostsNoHistory: "ยังไม่มีประวัติรายผู้จัด (host) จึงไม่มีข้อมูล Active hosts",
      activeHostsBeforeCoverage:
        "ข้อมูล host เริ่มวันที่ {{from}} — ช่วงที่เลือกอยู่ก่อนหน้านั้นทั้งหมด จึงไม่มีข้อมูล Active hosts",
      activeHostsPartialCoverage:
        "ข้อมูล host เริ่มวันที่ {{from}} — แท่งกราฟก่อนหน้านั้นไม่มีข้อมูล และยอดรวม Active hosts นับเฉพาะ {{from}} – {{end}}",
      activeHostsPartialBuckets:
        "ช่วงที่มีเครื่องหมาย * มีประวัติ host ไม่ครบ (จำนวน event ในประวัติน้อยกว่ายอด meeting หรือช่วงนั้นเริ่มก่อนข้อมูล host) ตัวเลข Active hosts ของช่วงนั้นจึงอาจต่ำกว่าจริง",
      heatmapMeetings: "Heatmap การใช้งาน — meetings",
      heatmapMinutes: "Heatmap การใช้งาน — นาที",
      noHeatmap: "ไม่มีกิจกรรมรายวันในช่วงนี้",
      less: "น้อย",
      more: "มาก",
      perUser: "การใช้งานต่อผู้ใช้",
      user: "ผู้ใช้",
      coverageNote:
        "ข้อมูลรายผู้ใช้ครอบคลุม ~{{pct}}% ของ meetings ในช่วงนี้ — ประวัติรายผู้จัด backfill น้อยกว่ายอดรวม จึงอาจอ่านได้ต่ำกว่า",
      noUsers: "ไม่มีกิจกรรมรายผู้ใช้ในช่วงนี้",
      eyebrow: "Zoom Usage Analysis · Sub-account Report",
      accountNumber: "เลขบัญชี {{number}}",
      footer: "รายงานการใช้งาน Zoom · {{account}} ({{number}}) · {{period}} · ออกรายงาน {{today}}",
      thinTitle: "ข้อมูลยังไม่พอทำรายงาน",
      emptyRange: "ไม่มีกิจกรรม meeting หรือ webinar ในช่วงที่เลือก",
      phoneTitle: "Zoom Phone",
      phoneTrend: "จำนวนสายต่อช่วงเวลา",
      phoneNoHistory: "ยังไม่มีข้อมูลการโทร จึงไม่มีข้อมูล Zoom Phone",
      phoneBeforeCoverage:
        "ข้อมูลการโทรเริ่มวันที่ {{from}} — ช่วงที่เลือกอยู่ก่อนหน้านั้นทั้งหมด จึงไม่มีข้อมูล Zoom Phone",
      phonePartialCoverage:
        "ข้อมูลการโทรเริ่มวันที่ {{from}} — แท่งกราฟก่อนหน้านั้นไม่มีข้อมูล และยอดรวม Zoom Phone นับเฉพาะ {{from}} – {{end}}",
      phonePartialBuckets:
        "ช่วงที่มีเครื่องหมาย * เริ่มก่อนข้อมูลการโทร ตัวเลขของช่วงนั้นจึงนับได้เพียงบางส่วน",
      phoneAllTypes: "สาย Zoom Phone แสดงทุกครั้ง ไม่ขึ้นกับตัวกรองประเภท",
    },
    // รายงานตัวที่สองของแท็บ Reports ("Insights" คู่กับ "reports"/มาตรฐานด้านบน) — ไม่มีส่วน Phone แล้ว
    // (เอาออก 2026-09-19 — ส่วน Zoom Phone ของรายงานมาตรฐานเป็นมุมมอง phone เดียว)
    reportsInsights: {
      kindLabel: "ประเภทรายงาน",
      kindStandard: "มาตรฐาน",
      kindInsights: "อินไซต์",
      licenseTitle: "การใช้สิทธิ์ License ตามที่นั่ง",
      licenseTrendTitle: "แนวโน้มการใช้สิทธิ์ — แผน {{plan}}",
      licenseKpiCurrent: "อัตราการใช้งานปัจจุบัน",
      licenseKpiAsOf: "ณ วันที่ {{date}}",
      licenseOtherPlansNote:
        "บัญชีนี้มีแผน license อื่นอีก {{count}} แผน — ดูรายละเอียดเต็มที่แท็บ Usage",
      licenseEmpty: "ไม่มีข้อมูล license snapshot ในช่วงนี้",
      sizeTitle: "การกระจายขนาด{{unit}}",
      sizeCaption: "จำนวน{{unit}}ตามจำนวนผู้เข้าร่วม",
      sizeUnitAttendees: "ผู้เข้าร่วม",
      sizeKpiAvg: "ผู้เข้าร่วมเฉลี่ยต่อครั้ง",
      sizeKpiTop: "ขนาดที่พบมากที่สุด",
      sizeEmpty: "ไม่มี meeting หรือ webinar ที่มีข้อมูลผู้เข้าร่วมในช่วงนี้",
      coverageNote:
        "กราฟนี้ครอบคลุม ~{{pct}}% ของกิจกรรมในยอดรวม — ประวัติระดับผู้จัด backfill น้อยกว่ายอดรายวัน จึงอาจอ่านได้ต่ำกว่าจริง",
      weeklyTitle: "รูปแบบการใช้งานรายสัปดาห์",
      weeklyByWeekdayCaption: "{{unit}}ตามวันในสัปดาห์",
      weeklyByHourCaption: "{{unit}}ตามช่วงเวลา (เวลากรุงเทพฯ)",
      weeklyEmpty: "ไม่มี meeting หรือ webinar ในช่วงนี้",
    },
    invoices: {
      number: "เลขใบแจ้งหนี้",
      poNumber: "เลข PO",
      searchBy: "ค้นด้วย",
      searchInvoice: "เลขใบแจ้งหนี้",
      searchPo: "เลข PO",
      searchPlaceholder: "เลขใบแจ้งหนี้ / PO",
      reset: "ล้าง",
      noMatch: "ไม่พบใบแจ้งหนี้ที่ตรง",
      noMatchBody:
        "ไม่มีใบแจ้งหนี้ตรงกับ filter — การค้นเป็นแบบเป๊ะ ตรวจเลขให้ครบ หรือขยายช่วงวันที่",
      date: "วันที่",
      due: "ครบกำหนด",
      dueDate: "วันครบกำหนด",
      amount: "จำนวนเงิน",
      tax: "ภาษี",
      balance: "ยอดคงเหลือ",
      source: "แหล่งข้อมูล",
      source_api: "ล่าสุด",
      source_pdf: "เก็บถาวร",
      source_unknown: "—",
      pdf: "PDF",
      hasPdf: "มี PDF",
      empty: "ไม่มีใบแจ้งหนี้",
      emptyBody: "ยังไม่มีใบแจ้งหนี้สำหรับบัญชีนี้",
      detailTitle: "ใบแจ้งหนี้ {{number}}",
      lineItems: "รายการ",
      charge: "รายการเรียกเก็บ",
      chargeType: "ประเภท",
      qty: "จำนวน",
      unitPrice: "ราคาต่อหน่วย",
      lineTotal: "รวม",
      noItems: "ไม่มีรายการในใบแจ้งหนี้นี้",
      viewPdf: "ดู PDF",
      downloadPdf: "ดาวน์โหลด PDF",
      pdfUnavailable: "ไม่มี PDF สำหรับใบแจ้งหนี้นี้",
      pdfError: "โหลด PDF ไม่สำเร็จ",
    },
    money: {
      billed12m: "ยอดเรียกเก็บ 12 เดือน",
      renewalAmount: "มูลค่าต่ออายุ",
      invoices: "ใบแจ้งหนี้",
      hidden: "คุณไม่มีสิทธิ์ดูข้อมูลด้านการเงิน",
    },
  },

  customers: {
    searchPlaceholder: "ค้นหาลูกค้าด้วยชื่อ เลขบัญชี หรือเจ้าของ",
    idleTitle: "ค้นหาลูกค้า",
    idleBody: "พิมพ์อย่างน้อย {{min}} ตัวอักษร — ชื่อ เลขบัญชี หรืออีเมลเจ้าของ",
    empty: "ไม่พบลูกค้า",
  },

  worklist: {
    subtitle: "งานที่ทีมต้องตามดูแล จัดกลุ่มตามความเร่งด่วน",
    // แคปชั่นกลุ่มของ health band (DashboardPage) — แบ่ง 7 tile เป็น 2 กลุ่ม กลุ่มละไม่เกิน 4 tile
    band: {
      actNow: "ต้องรีบทำ",
      review: "ควรตรวจสอบ",
    },
    renewal: "ใกล้หมดอายุ",
    churn: "เสี่ยงเลิกใช้",
    upsell: "License ไม่ตรง (assign เกินซื้อ)",
    underutilized: "ใช้งานน้อย",
    // "ใกล้หมด" (ยังใช้อยู่ — รีบไปปิดการขาย) ต้องแยกให้ขาดจาก "Trial หมดแล้ว" (จบไปแล้ว ไม่เคยซื้อ)
    trial_expiring: "Trial ใกล้หมด (ยังใช้อยู่)",
    empty: "ไม่มีรายการ",
    emptyBody: "ยังไม่มีบัญชีในกลุ่มนี้",
    col: {
      account: "บัญชี",
      daysUntilRenewal: "วันคงเหลือ",
      trialEnds: "Trial หมดวันที่",
      overdue: "เลยมาแล้ว {{days}} วัน",
    },
    addonWaste: {
      title: "Add-on ที่มีสิทธิ์ว่าง",
      addon: "ส่วนเสริม",
      purchased: "ที่ซื้อ",
      assigned: "ใช้ไปแล้ว",
      waste: "สิทธิ์ว่าง",
      emptyBody: "ไม่มีบัญชีที่มี add-on seat ว่าง",
      cat: {
        webinar: "เว็บบินาร์",
        large_meeting: "ประชุมใหญ่",
        phone: "Zoom Phone",
      },
    },
    // ── สองลิสต์ที่ชื่อคล้ายกันจนอันตราย — คำอธิบายต้องแยกให้ขาด ───────────────────────────────────
    //   "Trial ใกล้หมด" (62)      = ยังใช้ trial อยู่ ยังไม่หมด → รีบไปปิดการขาย
    //   "Trial หมดแล้ว" (50)      = หมดไปแล้ว ไม่เคยซื้อ       → ลิสต์ผู้มุ่งหวัง เริ่มการขายใหม่
    lapsedTrial: {
      title: "Trial หมดแล้ว (ยังไม่เคยซื้อ)",
      // น้ำเสียง = "โอกาส" ไม่ใช่ "ความผิดพลาด" — คนกลุ่มนี้แค่ลองแล้วยังไม่ซื้อ ไม่มีอะไรพัง
      // หนึ่งบรรทัด: ลิสต์นี้คืออะไร + ต้องทำอะไร เหตุผลที่เหลืออยู่ในคอมเมนต์ ไม่ใช่บนหน้าจอคนทำงาน
      note: "Trial ที่หมดอายุแล้วและไม่ได้ซื้อต่อ — ยังไม่เคยจ่ายเงินให้เรา โทรไปปิดการขายครั้งแรก",
      seatsTrialled: "Seat ที่ลองใช้",
      lapsedOn: "หมดอายุเมื่อ",
      daysSince: "ผ่านมาแล้ว {{days}} วัน",
      emptyTitle: "ไม่มี trial ที่หมดอายุค้างอยู่",
      emptyBody: "ยังไม่มีบัญชีที่ trial หมดแล้วและไม่เคยซื้อ",
    },
  },

  // บัญชีที่ Zoom ไม่ลิสต์แล้ว — แสดงเป็น badge ทุกที่ที่คนตั้งใจเปิดหาบัญชีนั้น (ค้นหา / Customer-360 /
  // worklist ต่ออายุ-เสี่ยงเลิกใช้-trial) ไม่เคยซ่อน เพราะการซ่อนคือการลบข้อมูลที่เขาต้องรู้
  retired: {
    badge: "ไม่อยู่ในรายการบัญชีของ Zoom แล้ว",
    badgeSince: "ไม่อยู่ในรายการบัญชีของ Zoom แล้ว (ตั้งแต่ {{date}})",
    badgeShort: "ไม่อยู่ในรายการ Zoom",
    // แบดจ์บอกว่า "หลุดจากรายการ" — แต่ต้องบอกต่อด้วยว่าตัวเลขทุกตัวถูกแช่ไว้ ZPCD หยุดรีเฟรชบัญชีทันทีที่หลุด
    // ดังนั้น utilization / วันครบกำหนด / จำนวน seat คือภาพนิ่งก่อนหลุด และจะไม่อัปเดตอีกเลย
    //
    // ⚠️ ตัดเหลือบรรทัดเดียว และตัวนี้ "ต้อง" ตัด: มันขึ้นเหนือ PlanFreezeNotice ทันที และมี 6 บัญชีบน prod ที่เป็นทั้ง
    // retired + paid_expired — คือหน้าที่สำคัญที่สุดในพอร์ทัล ลูกค้าที่จ่ายเงินแล้วแต่ Zoom ขึ้นหมดอายุ และหลุดจากรายการด้วย
    // หน้าพวกนั้นเคยขึ้นย่อหน้ายาวก่อน แล้วตามด้วยบรรทัดสั้นที่บอกเรื่องเดียวกัน — noise บังสัญญาณ ซึ่งคือปัญหาที่ brach นี้เกิดมาแก้
    frozen: "ตัวเลขถูกแช่ไว้ — บัญชีนี้หลุดจากรายการบัญชีของ Zoom แล้ว",
    frozenSince: "ตัวเลขถูกแช่ไว้ตั้งแต่ {{date}} — วันที่บัญชีนี้หลุดจากรายการบัญชีของ Zoom",
    frozenCell: "ตัวเลขถูกแช่ไว้ — บัญชีหลุดจากรายการ Zoom แล้ว",
  },

  // ── plan_state — "Zoom บอกว่า X" ไม่ใช่ "X เป็นความจริง" ────────────────────────────────────────
  // Zoom แจก Trial ให้บัญชีไหนก็ได้ พอหมดอายุ บัญชีจะตกไปเป็น Basic เงียบๆ แล้ว /plans/usage ก็หยุดตอบ
  // ตัวเลข seat/licence ที่ค้างอยู่จึงถูกแช่ไว้ตลอดกาล — portal เคยเอามาโชว์เป็นของปัจจุบัน
  //
  // ⚠️ กับดัก: status='expired' คือ "คำกล่าวอ้างของ Zoom" ไม่ใช่ "ข้อเท็จจริง" — QUALICA จ่ายเงินมา 4 ปีติด
  // แล้ว Zoom พลิกเป็น expired ข้ามคืน (มีเคสเปิดค้างกับ Zoom อยู่) ถ้าคำที่ใช้อ่านเหมือน "ป้ายหลุมศพ"
  // CSM จะเลิกโทรหาลูกค้าที่ยังจ่ายเงินอยู่ — นั่นคือความเสียหายที่แย่กว่าบั๊กเดิม
  // สีแดง = "ด่วน" / คำพูด = "ให้ไปเช็ค" ไม่ใช่ "ตายแล้ว"
  planState: {
    // เหลือแค่ 2 อย่างในนี้: label seat ที่ถูกแช่ไว้ กับข้อความ freeze notice บนแท็บ Usage ด้านล่าง — badge
    // สถานะแพลน 7 แบบ ถูกยุบเป็นสถานะบัญชี 4 ค่า (accountStatus.* / lib/accountStatus.ts) ตามที่คุณใหม่สั่ง
    // (badge ยาวๆ พวก ⚠️ Zoom บอกว่าหมดอายุ…, ⚠️ เคสค้าง… คือความรกที่ตัดออกรอบนี้) isPlanNotLive ยังใช้ตัดสิน
    // ว่าจะขึ้น freeze notice ไหม และตัวเลข seat ที่ถูกแช่ก็ยังติดป้ายบอกตามจริง
    seatsLastKnown: "Seat (ล่าสุดที่ทราบ)",

    // ── ข้อความแจ้ง "ตัวเลขถูกแช่" บนแท็บ Usage ─────────────────────────────────────────────────────
    // พอแพลนหลักไม่ live แล้ว Zoom จะไม่ตอบ /plans/usage ของบัญชีนี้อีกเลย ตัวเลขทุกตัวบนแท็บนั้นจึงถูกแช่ไว้
    // ตั้งแต่วันที่ trial/แพลนที่จ่ายเงินจบลง — การโชว์ "ซื้อ 15 / ใช้ 1" เฉยๆ คือบั๊ก
    //
    // หนึ่งบรรทัด: เกิดอะไรขึ้น (+ ต้องทำอะไร ถ้ามี) เท่านั้น เหตุผลอยู่ในคอมเมนต์
    // ⚠️ `age` ("Zoom รีเฟรชครั้งล่าสุดเมื่อ N วันที่แล้ว") ถูกลบทิ้ง — "0 วันที่แล้ว" ไม่ได้บอกอะไรเลย และมันไป
    // ขัดกับประโยคที่เพิ่งบอกว่าตัวเลขจะไม่อัปเดตอีก คำเตือนที่แย้งตัวเองคือคำเตือนที่ไม่มีใครเชื่อ
    freeze: {
      lapsedTrial: "Trial หมดอายุแล้ว — ตัวเลขด้านล่างเป็นค่าล่าสุดที่ทราบ ไม่ใช่ค่าปัจจุบัน",
      paidExpired:
        "⚠️ Zoom บอกว่าหมดอายุ แต่บัญชีนี้จ่ายเงินให้เราแล้ว — ตัวเลขด้านล่างเป็นค่าล่าสุดที่ทราบ ไม่ใช่ค่าปัจจุบัน เช็คกับ Zoom ก่อนปิดเคส",
      expiredOther: "แพลนหมดอายุแล้ว — ตัวเลขด้านล่างเป็นค่าล่าสุดที่ทราบ ไม่ใช่ค่าปัจจุบัน",
      cancelled: "แพลนถูกยกเลิกแล้ว — ตัวเลขด้านล่างเป็นค่าล่าสุดที่ทราบ ไม่ใช่ค่าปัจจุบัน",
      // ── รอบ 3, ruling 2 — บัญชีติด badge Active ทั้งที่ plan_state เองบอกว่าไม่ live (≈39 บัญชีบน local
      // mirror) ตัวเลขด้านล่างยังเป็นค่าล่าสุดที่เคยมีเหมือนเดิม — เปลี่ยนแค่ประโยค "แพลนหมดอายุแล้ว" ที่ไม่จริง
      // ออกไป สองแบบ โทนเป็น warn เสมอ ไม่ใช่ danger แบบ paid_expired เพราะบัญชีนี้ Active อยู่จริงใน Zoom
      activePhoneOnly:
        "บัญชีนี้ไม่มี meeting plan — ใช้ Zoom Phone อย่างเดียว ตัวเลข meeting ด้านล่างเป็นค่าล่าสุดที่เคยมี ไม่ใช่ค่าปัจจุบัน",
      activeNotLive:
        "Zoom ยังแสดงรายการที่ active อยู่ในบัญชีนี้ — ตัวเลขด้านล่างเป็นค่าล่าสุดที่เคยมี ไม่ใช่ค่าปัจจุบัน",
    },
  },

  adminUsers: {
    title: "ผู้ใช้งาน",
    subtitle: "ทีมงานที่เข้าใช้ portal ได้ — สิทธิ์และการเข้าถึง",
    colUser: "ผู้ใช้",
    colRole: "บทบาท",
    colStatus: "สถานะ",
    colLastLogin: "เข้าใช้ล่าสุด",
    colLastSeen: "พบล่าสุด",
    colActions: "จัดการ",
    status: {
      active: "ใช้งาน",
      disabled: "ปิดใช้งาน",
      invited: "เชิญแล้ว",
      not_invited: "ยังไม่ได้เชิญ",
      off_roster: "ไม่อยู่ใน roster",
      revoked: "ถูกถอดสิทธิ์",
    },
    statusHelp: {
      invited: "เชิญแล้ว — สร้างบัญชีให้เรียบร้อย รอเขาเข้าสู่ระบบครั้งแรก",
      not_invited: "อยู่ใน staff roster แต่ยังไม่ได้เชิญ — ส่งคำเชิญเพื่อให้สิทธิ์เข้าใช้งาน",
      off_roster: "มีบัญชีแต่ถูกถอดจาก staff roster — เข้าใช้ไม่ได้",
      disabled: "ปิดการเข้าถึงไว้ (kill-switch)",
      revoked:
        "แอดมินลบออกจาก portal แล้ว — กลับไปเป็นแค่รายชื่อใน Zoom roster ต้องกดเชิญใหม่เท่านั้นถึงจะกลับเข้ามาได้",
    },
    changeRole: "เปลี่ยนบทบาท",
    enable: "เปิดการเข้าถึง",
    disable: "ปิดการเข้าถึง",
    roleDialogTitle: "เปลี่ยนบทบาท",
    roleDialogBody:
      "Owner & Admin เห็นทุกอย่างรวมถึงข้อมูลเงิน · Viewer ไม่เห็นเงิน · Custom คือชุดสิทธิ์ที่กำหนดเอง",
    roleLabel: "บทบาท",
    customPermsLabel: "สิทธิ์ที่กำหนดเอง",
    customPermsNote: "การบันทึกจะแทนที่ชุดสิทธิ์ทั้งหมดของผู้ใช้นี้",
    roleUpdated: "อัปเดตบทบาทแล้ว",
    accessUpdated: "อัปเดตการเข้าถึงแล้ว",
    disableDialogTitle: "ปิดการเข้าถึง?",
    disableDialogBody: "{{email}} จะถูกบล็อกในคำขอถัดไป เปิดกลับได้ตลอดเวลา",
    enableDialogTitle: "เปิดการเข้าถึง?",
    enableDialogBody: "{{email}} จะกลับมาเข้าใช้ได้เมื่อล็อกอินครั้งถัดไป",
    save: "บันทึก",
    never: "ไม่เคย",
    errorTitle: "ทำรายการไม่สำเร็จ",
    empty: "ไม่มีผู้ใช้ portal",
    emptyBody: "ยังไม่มีทีมงานที่เข้าถึง portal ได้",
    tabPortal: "ผู้ใช้ Portal",
    tabRoster: "รายชื่อ Zoom",
    portalHint: "ทีมงานที่เข้าสู่ระบบ portal แล้ว",
    rosterHint: "ทีมงานที่ sync มาจาก Zoom แต่ยังไม่เคยเข้าใช้ — กดเชิญให้เข้าร่วม",
    colInvited: "สถานะเชิญ",
    notInvited: "ยังไม่เชิญ",
    invitedAt: "เชิญเมื่อ {{time}}",
    invite: "เชิญ",
    reinvite: "เชิญอีกครั้ง",
    sendInvite: "ส่งคำเชิญ",
    inviteDialogTitle: "ส่งคำเชิญเข้า portal?",
    inviteDialogBody:
      "จะส่งอีเมลคำเชิญเข้า portal ไปที่ {{email}} — ผู้รับเข้าใช้ด้วยอีเมล 1TOALL แล้วรับรหัส 6 หลักทางอีเมลเพื่อยืนยัน (ไม่มีรหัสผ่าน)",
    inviteSent: "ส่งคำเชิญไปที่ {{email}} แล้ว",
    inviteRecorded: "บันทึกคำเชิญแล้ว",
    inviteEmailFailed: "ส่งอีเมลไม่สำเร็จ (SMTP ยังไม่ตั้งค่า) — แต่บันทึกคำเชิญไว้แล้ว",
    cancelInvite: "ยกเลิกคำเชิญ",
    keepInvite: "เก็บคำเชิญไว้",
    inviteCancelled: "ยกเลิกคำเชิญแล้ว",
    cancelInviteDialogTitle: "ยกเลิกคำเชิญนี้?",
    cancelInviteDialogBody:
      "จะถอนคำเชิญที่ค้างอยู่ของ {{email}} และลบบัญชีที่คำเชิญนั้นสร้างไว้ — เขาจะกลับไปเป็นแค่รายชื่อใน Zoom roster และเข้าสู่ระบบไม่ได้ กดเชิญใหม่คือทางเดียวที่พาเขากลับเข้ามาได้",
    searchPlaceholder: "ค้นหาชื่อหรืออีเมล",
    rosterEmpty: "ไม่มีคำเชิญค้าง",
    rosterEmptyBody: "ทุกคนใน Zoom staff roster เข้าใช้ระบบแล้ว",

    // --- ลบผู้ใช้ออกจาก portal (ต้องปิดการเข้าถึงก่อน) ---
    delete: "ลบออก",
    deleteDialogTitle: "ลบออกจาก portal?",
    deleteDialogBody:
      "{{email}} จะถูกลบออกจากรายชื่อผู้ใช้ Portal — บทบาทและสิทธิ์ทั้งหมดจะถูกลบไปด้วย",
    deleteDialogConsequence:
      "เขาจะกลับไปเป็นแค่รายชื่อใน Zoom roster และเข้า portal ไม่ได้อีก จนกว่าแอดมินจะกดเชิญใหม่ — การกดเชิญคือทางเดียวที่พาเขากลับเข้ามาได้",
    deleteConfirm: "ลบออกจาก portal",
    deleted: "ลบ {{email}} ออกจาก portal แล้ว",
    deletedBody: "ตอนนี้กลับไปอยู่ใน Zoom roster — กดเชิญเมื่อต้องการให้กลับเข้ามา",
    deleteBlockedTitle: "ลบผู้ใช้นี้ไม่ได้",
    deleteBlocked: {
      self: "ลบบัญชีตัวเองไม่ได้ ({{email}})",
      selfFix: "ให้ Owner คนอื่นเป็นคนลบให้ค่ะ",
      ownerNeedsOwner: "เฉพาะ Owner เท่านั้นที่ลบ Owner ได้ — {{email}} เป็น Owner",
      ownerNeedsOwnerFix: "ให้ Owner เป็นคนลบ หรือเปลี่ยนบทบาทของเขาก่อน",
      stillActive:
        "{{email}} ยังเข้าใช้งานได้อยู่ — ต้องปิดการเข้าถึงก่อน ระบบจะลบได้เฉพาะบัญชีที่ปิดไว้แล้วเท่านั้น",
      stillActiveFix: 'กด "ปิดการเข้าถึง" ก่อน แล้วค่อยลบ — ตั้งใจให้เป็นสองจังหวะ กันกดพลาด',
      lastOwner: "{{email}} เป็น Owner คนสุดท้ายของ portal — ลบแล้วจะไม่เหลือใครดูแลระบบได้",
      lastOwnerFix:
        "ตั้งคนอื่นเป็น Owner ก่อน — ตอนนี้บัญชี Owner ที่ปิดไว้อยู่นี้คือทางกลับเข้าระบบทางเดียว",
    },
    revokedAt: "ถูกถอดสิทธิ์เมื่อ {{time}} โดย {{email}}",
    inviteBack: "เชิญกลับเข้ามา",
    inviteRestored: "คนนี้เคยถูกถอดสิทธิ์ไว้ — การเชิญครั้งนี้คืนสิทธิ์เข้า portal ให้เขาแล้ว",

    // --- ปุ่ม Sync users now (roster ยังซิงก์เองทุกวัน 02:30) ---
    rosterSync: {
      button: "Sync ผู้ใช้เดี๋ยวนี้",
      autoNote: "roster ซิงก์อัตโนมัติทุกวันเวลา 02:30 (เวลาไทย) อยู่แล้ว",
      lastSynced: "roster ซิงก์ล่าสุดเมื่อ {{time}}",
      failedTitle: "ซิงก์ roster ไม่สำเร็จ",
      rosterIntact: "roster เดิมยังอยู่ครบ — {{n}} คน ไม่มีใครหลุดสิทธิ์",
      result: {
        ok: "ซิงก์ทีมงานจาก Zoom แล้ว {{n}} คน",
        throttled: "เพิ่งซิงก์ไป — ลองใหม่อีกครั้งใน {{seconds}} วินาที",
        alreadyRunning: "มีการซิงก์ roster ทำงานอยู่แล้ว",
        zoomError: "เรียก Zoom ไม่สำเร็จ — ยังไม่ได้ซิงก์ roster",
        empty: "Zoom ส่งกลับมา 0 คน — ระบบไม่เชื่อค่านี้ จึงไม่ซิงก์ roster",
        suspicious:
          "Zoom ส่งรายชื่อกลับมาน้อยผิดปกติ ถ้าเชื่อตามนั้นจะมีคนหลุดออกจาก portal ถึง {{n}} คน — ระบบไม่เชื่อ จึงไม่แก้ไขอะไรเลย ลองตรวจใน Zoom แล้วกดใหม่อีกครั้ง",
        notConfigured: "deployment นี้ยังไม่ได้ตั้งค่า Zoom app ของทีมงาน",
        unknown: "ซิงก์แล้วได้ผลลัพธ์ที่ portal ไม่รู้จัก — ให้ถือว่าไม่สำเร็จ",
      },
    },

    // MUST stay total over the `Permission` union in api/types.ts. The permissions modal renders
    // t(`adminUsers.permLabel.${p}`) with p: Permission, so a permission with no label here renders its
    // RAW KEY at an admin ("adminUsers.permLabel.user:manage"). user:manage / config:manage were missing
    // and only stayed invisible because GRANTABLE happens not to list them yet — a trap armed for whoever
    // grants those next. tsc now enforces the totality: add a Permission, add its label, or the build fails.
    permLabel: {
      "search:read": "ค้นหา",
      "customer:read": "ลูกค้า",
      "money:read": "เงิน / ใบแจ้งหนี้",
      "worklist:read": "งานที่ต้องดูแล",
      "audit:read": "บันทึกการใช้งาน",
      "user:manage": "จัดการผู้ใช้",
      "config:manage": "จัดการการตั้งค่า",
    },
  },

  activity: {
    title: "บันทึกการใช้งาน",
    subtitle: "การเข้าสู่ระบบและการเข้าถึงข้อมูลทั้ง portal",
    filterKind: "ประเภทเหตุการณ์",
    filterActor: "อีเมลผู้ใช้",
    actorPlaceholder: "อีเมลแบบตรง…",
    from: "ตั้งแต่",
    to: "ถึง",
    clear: "ล้าง",
    allKinds: "ทุกเหตุการณ์",
    kind: {
      login_success: "เข้าสู่ระบบสำเร็จ",
      login_failed: "เข้าสู่ระบบล้มเหลว",
      logout: "ออกจากระบบ",
      data_access: "เข้าถึงข้อมูล",
      money_access: "เข้าถึงข้อมูลเงิน",
      admin_action: "การจัดการระบบ",
      sync_now: "ดึงข้อมูลสด",
    },
    colTime: "เวลา",
    colActor: "ผู้ใช้",
    colEvent: "เหตุการณ์",
    colTarget: "เป้าหมาย / รายละเอียด",
    colIp: "IP",
    loadMore: "โหลดเพิ่ม",
    end: "สิ้นสุดผลลัพธ์",
    empty: "ไม่มีกิจกรรม",
    emptyBody: "ไม่มีเหตุการณ์ที่ตรงกับตัวกรอง",
    account: "บัญชี {{id}}",
    roleChange: "{{from}} → {{to}}",
  },

  home: {
    greeting: "ยินดีต้อนรับ",
    subtitle: "{{role}} · {{email}}",
    search: {
      title: "ค้นหาลูกค้า ผู้ใช้ หรือใบแจ้งหนี้",
      body: "พิมพ์อีเมล ชื่อบัญชี เลขบัญชี เจ้าของ หรือเลขใบแจ้งหนี้ — กด ⌘K ได้ทุกหน้า",
    },
    worklist: {
      heading: "งานที่ต้องดูแลวันนี้",
      viewAll: "ดูทั้งหมด",
    },
    quick: {
      heading: "ทางลัด",
      search: {
        title: "ค้นหาลูกค้า",
        body: "ค้นจากอีเมล ชื่อบัญชี เลขบัญชี เจ้าของ หรือเลขใบแจ้งหนี้ (กด ⌘K ได้ทุกหน้า)",
      },
      customers: {
        title: "เปิดข้อมูลลูกค้า",
        body: "ดูภาพรวม แพ็กเกจ การใช้งาน ผู้ใช้ และใบแจ้งหนี้ของแต่ละบัญชี",
      },
      worklists: {
        title: "งานที่ต้องดูแล",
        body: "ลูกค้าใกล้หมดอายุ เสี่ยงเลิกใช้ โอกาสขายเพิ่ม และใช้งานน้อย",
      },
    },
  },

  search: {
    omniboxLabel: "ค้นหาทั่วทั้งระบบ",
    inputLabel: "ค้นหาลูกค้า ผู้ใช้ และใบแจ้งหนี้",
    resultsLabel: "ผลการค้นหา",
    idleTitle: "พิมพ์เพื่อค้นหา",
    idleBody:
      "พิมพ์อย่างน้อย {{min}} ตัวอักษร — อีเมล ชื่อบัญชี เลขบัญชี เจ้าของ หรือเลขใบแจ้งหนี้",
    emptyTitle: "ไม่พบผลลัพธ์",
    emptyBody: "ไม่พบข้อมูลที่ตรงกับ “{{term}}”",
    noPermission: "บัญชีของคุณไม่มีสิทธิ์ค้นหา",
    groups: {
      members: "ผู้ใช้",
      accounts: "บัญชีลูกค้า",
      invoices: "ใบแจ้งหนี้",
    },
    drillHint: {
      member: "เปิดแท็บผู้ใช้",
      pending: "เปิดแท็บรอตอบรับ",
      account: "เปิดข้อมูลลูกค้า",
      invoice: "เปิดแท็บใบแจ้งหนี้",
    },
    // K2-A: แสดงบนใบแจ้งหนี้ที่ยังไม่ทราบว่าเป็นของลูกค้ารายใด (account_id ว่าง) — กดไม่ได้
    unattributedInvoice: "ยังไม่ระบุบัญชี",
    // R7 (final review): ใบแจ้งหนี้ของ 1TOALL master account เอง (เช่น 941855) — แยกจากที่ยัง
    // ไม่ระบุบัญชีจริงๆ ให้ตรงกับป้าย "1TOALL master (941855)" ใน Excel ของ ZPCD
    masterAccountInvoice: "1TOALL master (941855)",
    // แถวของผู้ถูกเชิญที่ยังไม่ตอบรับ: บัญชีที่เชิญ — {{account}} = ชื่อ · เลขบัญชี
    pendingInvite: "คำเชิญรอตอบรับ · {{account}}",
  },

  syncNow: {
    title: "ดึงข้อมูลสด",
    help: "ดึงแพ็กเกจและการใช้งานล่าสุดจาก Zoom สดตอนนี้ (ใช้โควตา) ข้อมูลจากภาพรวมด้านบนมาจาก sync รายคืน",
    lastSynced: "ซิงค์ล่าสุด {{time}}",
    success: "ดึงข้อมูลสดสำเร็จ",
    deduped: "คำขอซ้ำกับครั้งก่อน จึงรวมเป็นครั้งเดียว",
    apiCalls: "ใช้โควตา {{count}} ครั้ง",
    quota: {
      title: "โควตาการดึงข้อมูล (Heavy/วัน)",
      onDemandRemaining: "โควตาสดคงเหลือ",
      capRemaining: "โควตารวมคงเหลือ",
      used: "ใช้ไป {{used}} จาก {{total}}",
      usedLabel: "ใช้ไปแล้ว",
      reserve: "กันไว้สำหรับ sync รายคืน {{reserve}}",
    },
    blocked: {
      quota: "โควตาการดึงข้อมูลสดหมดแล้ว ระบบกันโควตาที่เหลือไว้สำหรับ sync รายคืน",
      throttle: "ขอข้อมูลถี่เกินไป รอสักครู่แล้วลองใหม่",
      dailySync:
        "ZPCD กำลังอัปเดตข้อมูลประจำวันอยู่ตอนนี้ — Sync now หยุดชั่วคราวเพื่อไม่ให้แย่งโควตา Zoom ที่ใช้ร่วมกัน กรุณาลองใหม่อีกครั้งในสักครู่",
      error: "ดึงข้อมูลจาก Zoom ไม่สำเร็จ",
      generic: "ดึงข้อมูลสดไม่สำเร็จ",
    },
    reason: {
      on_demand_budget_exhausted: "โควตาสดประจำวันหมดแล้ว",
      // การ์ดเพดานรวมรายวัน (quota.py would_block): โควตาสดอาจยังเหลือ แต่ยอดรวมของ sync รายคืน +
      // ดึงสด จะกินส่วนที่กันไว้ให้ sync รายคืน — คนละเหตุกับ on_demand_budget_exhausted
      daily_cap_would_starve_nightly:
        "โควตา Heavy ประจำวันหมดแล้ว ส่วนที่เหลือกันไว้สำหรับ sync รายคืน",
      per_second_rate_limit: "ขอข้อมูลถี่เกินกำหนดต่อวินาที",
      per_operator_daily_cap_reached: "คุณดึงข้อมูลสดครบโควตาต่อวันแล้ว",
      zpcd_daily_sync_in_progress: "กำลัง sync รายวันอยู่ — หยุดชั่วคราวสักครู่",
      peak_window_blind_fallback: "อาจกำลัง sync รายวันอยู่ — หยุดชั่วคราวเพื่อความปลอดภัย",
      duplicate_within_dedupe_window: "คำขอซ้ำกับครั้งก่อนหน้า",
      syncnow_zoom_app_not_configured: "ยังไม่ได้ตั้งค่าแอป Zoom สำหรับดึงสด",
      // Zoom HTTP errors arrive as "zoom_error:<code>" (the colon resolves as a flat leaf key because
      // nsSeparator is disabled). Common codes get specific copy; the rest fall back to blocked.error.
      "zoom_error:429": "Zoom จำกัดอัตราการเรียก ลองใหม่อีกครั้งในอีกสักครู่",
      "zoom_error:500": "Zoom ขัดข้องชั่วคราว ลองใหม่อีกครั้ง",
      "zoom_error:502": "เชื่อมต่อ Zoom ไม่สำเร็จชั่วคราว ลองใหม่อีกครั้ง",
      "zoom_error:503": "บริการ Zoom ไม่พร้อมใช้งานชั่วคราว ลองใหม่ภายหลัง",
    },
    // Auth/transport failures (not a Zoom envelope) — must steer to re-auth, NOT retry-against-Zoom.
    error: {
      authExpired: "เซสชันหมดอายุหรือไม่มีสิทธิ์ กรุณาเข้าสู่ระบบใหม่",
    },
  },

  state: {
    loading: "กำลังโหลด…",
    // aria-label ของ spinner เล็กๆ ที่แทนตัวเลขระหว่างรอโหลด (stat tile / KPI count) — ไม่ใส่ "…"
    // เพราะ screen reader อ่านครั้งเดียวเป็นคำ ไม่ใช่ประโยค
    loadingValue: "กำลังโหลด",
    emptyTitle: "ไม่มีข้อมูล",
    // r1 critique (24/7): ข้อความเดิมบอกไม่ได้ว่า "ว่างจริงๆ" หรือ "พังเงียบๆ" — อันนี้บอกทิศทางที่น่าจะเป็น
    // พร้อมขั้นตอนถัดไปสั้นๆ หนึ่งอย่าง
    emptyBody: "ตอนนี้ยังไม่มีข้อมูล — ลองรีเฟรชถ้าคิดว่าควรมีข้อมูลแล้ว",
    errorTitle: "เกิดข้อผิดพลาด",
    errorBody:
      "โหลดข้อมูลไม่สำเร็จ อาจเป็นปัญหาชั่วคราว ลองใหม่อีกครั้ง หรือรีเฟรชหน้าถ้ายังไม่ได้",
    notFoundTitle: "ไม่พบข้อมูล",
    forbiddenTitle: "ไม่มีสิทธิ์เข้าถึง",
    forbiddenBody: "บัญชีของคุณไม่มีสิทธิ์ดูส่วนนี้",
    networkError: "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้",
    requestId: "รหัสคำขอ: {{id}}",
  },

  auth: {
    signingIn: "กำลังเข้าสู่ระบบ…",
    signInRequired: "กรุณาเข้าสู่ระบบ",
    signIn: "เข้าสู่ระบบ",
    notStaff:
      "บัญชีนี้ไม่ได้อยู่ในรายชื่อทีมงาน กรุณาติดต่อผู้ดูแลระบบ หรือเข้าสู่ระบบด้วยบัญชีอื่น",
    notStaffTitle: "ไม่มีสิทธิ์เข้าใช้งาน",
    signInAnother: "เข้าสู่ระบบด้วยบัญชีอื่น",
    signOut: "ออกจากระบบ",
    staffOnly: "สำหรับทีมงาน 1TOALL เท่านั้น",
    loadingProfile: "กำลังโหลดข้อมูลผู้ใช้…",
    sessionExpiredTitle: "เซสชันหมดอายุ",
    sessionExpiredBody: "การเข้าสู่ระบบของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้งเพื่อใช้งานต่อ",
    sessionConfigTitle: "เข้าสู่ระบบไม่สำเร็จ",
    sessionConfigBody:
      "ระบบเข้าสู่ระบบให้ไม่สำเร็จ อาจเป็นปัญหาการตั้งค่า กรุณาติดต่อผู้ดูแลระบบพอร์ทัล",
  },

  acceptInvite: {
    title: "ยืนยันคำเชิญ",
    validating: "กำลังตรวจสอบคำเชิญ…",
    validBody: "คุณได้รับเชิญให้เข้าใช้งาน portal — เข้าสู่ระบบด้วย {{email}} เพื่อเริ่มใช้งาน",
    signIn: "เข้าสู่ระบบ",
    invalidTitle: "คำเชิญนี้ใช้ไม่ได้",
    invalidBody: "ลิงก์คำเชิญหมดอายุหรือถูกใช้ไปแล้ว กรุณาขอให้ผู้ดูแลระบบส่งคำเชิญใหม่",
    missingToken: "ลิงก์คำเชิญไม่สมบูรณ์ กรุณาขอให้ผู้ดูแลระบบส่งคำเชิญใหม่",
  },

  // สถานะแพลนของบัญชี ยุบเหลือ 4 ค่าเพื่อหน้าจอ monitor (lib/accountStatus.ts) — คนละบล็อกกับ `status` ด้านล่าง
  // (ที่ไว้แปะ label ให้ token ดิบของ Zoom เรื่อง account/invoice/subscription) นี่คือ 4 ค่าที่พอร์ทัล derive เอง
  accountStatus: {
    active: "ใช้งาน",
    free: "ฟรี",
    expired: "หมดอายุ",
    unknown: "ไม่ทราบ",
    unknownHint: "ยังระบุรหัสแพลนไม่ได้ — ไม่ต้องทำอะไร",
    // รอบ 3, ruling 3: คำว่า "ไม่ทราบ" คำเดียวกัน แต่มาจากอีกสาเหตุ — server ไม่มีข้อมูลแพลนของบัญชีนี้เลย
    // (ไม่ใช่ Free และไม่มีรายการที่ render ได้เลย) ไม่ใช่แค่รหัสแพลนที่เรายังไม่รู้จัก
    noPlanDataHint: "ระบบยังไม่มีข้อมูลแพลนของบัญชีนี้",
  },

  // badge การ sign-in ของ owner (ADR ACTIVATION-BADGE §Display, lib/activationStatus.ts) — คุณใหม่ตัดสิน 14/9 ค่ำ:
  // แสดงแค่ 3 ข้อความ เป็นภาษาอังกฤษเหมือนกันทั้ง th และ en (ไม่แปล) · ห้ามสีแดง/เหลือง ห้ามข้อความเชิงลบ ·
  // "Pending" = ระบบกำลังเฝ้ารอ owner sign-in ครั้งแรก (≤90 วัน) · "Unknown" = ยังไม่มีหลักฐาน · ทั้งคู่ไม่ได้อ้างอะไรเชิงลบ · ทุก string ในบล็อกนี้ต้องตรงกับ en.ts ตัวต่อตัว (มีเทสตรึง)
  activation: {
    state: {
      activated: "Activate: Activated",
      pending: "Activate: Pending",
      unknown: "Activate: Unknown",
    },
    hint: {
      activated: "The owner account has signed in",
      pending: "Watching for the owner's first sign-in",
      unknown: "Owner sign-in status is unknown",
    },
    checkedAt: "Checked {{time}}",
    notUpdating: "Not updating",
    notUpdatingSince: "Not updating · last checked {{time}}",
  },

  status: {
    active: "ใช้งาน",
    inactive: "ไม่ใช้งาน",
    paid: "ชำระแล้ว",
    pending: "รอดำเนินการ",
    overdue: "เกินกำหนด",
    // Statuses that statusTone() already colours but were missing copy → previously rendered raw DB value.
    expiring: "ใกล้หมดอายุ",
    expired: "หมดอายุ",
    cancelled: "ยกเลิกแล้ว",
    suspended: "ระงับการใช้งาน",
    trial: "ทดลองใช้",
    // Invoice statuses (Zoom billing)
    collected: "เก็บเงินแล้ว",
    credit: "เครดิต",
    open: "ค้างชำระ",
    sent: "ส่งแล้ว",
    void: "ยกเลิก",
    posted: "บันทึกแล้ว",
    draft: "ฉบับร่าง",
  },

  daterange: {
    label: "เลือกช่วงวันที่",
    from: "ตั้งแต่",
    to: "ถึง",
    // Validation copy. These three keys did not exist: the component passed the English text as a
    // `defaultValue`, so i18n was bypassed entirely and a Thai operator would have been shown English.
    invalid: "กรุณากรอกวันที่ให้ถูกต้อง (DD/MM/YYYY)",
    order: "วันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด",
    adjusted: "ปรับให้อยู่ในช่วงวันที่ที่อนุญาตแล้ว",
  },

  // 31/7 — DatePicker (วันที่เดียว) สร้างจาก internals ที่ใช้ร่วมกับ DateRangePicker (dateFieldShared.tsx)
  // มีคำแปลของตัวเอง ไม่ใช้ daterange.* ร่วมกันทั้งหมด — วันที่เดียวไม่มีคู่ "ตั้งแต่/ถึง" และไม่มี error
  // ลำดับก่อน-หลังแบบ daterange.order เพราะไม่มีจุดเทียบ
  datepicker: {
    label: "เลือกวันที่",
    placeholder: "เลือกวันที่",
    invalid: "กรุณากรอกวันที่ให้ถูกต้อง (DD/MM/YYYY)",
    // (31/7 พ.2) ถอน `adjusted` — ตายตั้งแต่ SEAM-3 เปลี่ยนจาก clamp-and-commit เป็น reject:
    // เหลือแค่ `outOfRange` ข้างล่างที่ขึ้นจอได้จริง
    // วันที่พิมพ์ถูกรูปแบบแต่อยู่นอกช่วง min/max — ไม่ commit และไม่ clamp เงียบๆ (SEAM-3):
    // ข้อความที่พิมพ์ไว้ยังอยู่เหมือนเดิม จนกว่าจะแก้ไขให้อยู่ในช่วง
    outOfRange: "วันที่นี้อยู่นอกช่วงวันที่ที่อนุญาต",
  },

  table: {
    results: "{{count}} รายการ",
    showing: "แสดง {{from}}–{{to}} จาก {{total}}",
    perPage: "แถวต่อหน้า",
    perPageN: "{{count}} ต่อหน้า",
    pagination: "แบ่งหน้า",
    prevPage: "หน้าก่อน",
    nextPage: "หน้าถัดไป",
    goToPage: "ไปหน้า {{n}}",
  },

  // 404 route. Same story as daterange.*: the keys never existed and the copy lived in the component as
  // `defaultValue`, so the 404 page was hardcoded English no matter the locale.
  notFound: {
    title: "ไม่พบหน้านี้",
    body: "หน้านี้ไม่มีอยู่ หรืออาจถูกย้ายไปแล้ว",
    home: "กลับไปหน้าแรก",
  },

  a11y: {
    sortedBy: "เรียงตาม {{column}}",
    closeDialog: "ปิดหน้าต่าง",
    notification: "การแจ้งเตือน",
  },

  // Pool module (Zoom license/period time-sharing, Phase 1). Every /pool/* route is gated by a
  // SEPARATE server-side allow-list (pool.operator) — nothing to do with Owner/Admin/Viewer roles —
  // so a 403 here means "not on the pool allow-list" and gets its OWN copy, never the generic
  // state.forbidden* strings above.
  pool: {
    notOperatorTitle: "ยังไม่ได้รับสิทธิ์ Online Channel operator",
    notOperatorBody:
      "บัญชีของคุณยังไม่อยู่ใน allow-list ของ Online Channel — ติดต่อ Owner ให้เพิ่มชื่อในหน้าตั้งค่า Online Channel",
    readOnlyNote:
      "คุณเป็น Online Channel operator แบบดูอย่างเดียว (read-only) — ไม่สามารถแก้ไขข้อมูลได้",

    tabs: {
      dashboard: "ภาพรวม",
      accounts: "บัญชี",
      users: "ผู้ใช้งาน",
      intents: "Intent ค้าง",
      reports: "รายงาน",
      settings: "ตั้งค่า",
      system: "ระบบ",
      audit: "บันทึกการใช้งาน",
    },

    settings: {
      title: "ตั้งค่า Online Channel",
      subtitle: "เลือกบัญชีที่จะเข้า Online Channel และดูแลบัญชีที่มีอยู่",

      addAccountTitle: "เพิ่มบัญชี",
      addAccountButton: "เพิ่ม Account",
      chooseTypePrompt: "จะเพิ่มบัญชีนี้แบบไหน?",
      modeSubAccount: "จากบัญชีที่มีอยู่",
      modeSubAccountDesc: "ค้นหาจาก sub account ที่มีอยู่ใน ZPCD mirror",
      modeCredential: "จาก Zoom credential",
      modeCredentialDesc: "กรอก credential ของบัญชี standalone",

      searchTitle: "เพิ่มบัญชี",
      searchPlaceholder: "ค้นหาด้วยชื่อบัญชีหรือเลขบัญชี",
      searchLabel: "ค้นหาบัญชีที่จะเพิ่ม",
      searchHint: "พิมพ์อย่างน้อย 2 ตัวอักษร",
      colAccountName: "ชื่อบัญชี",
      colAccountNumber: "เลขบัญชี",
      colAccountType: "ประเภทบัญชี",
      colSeats: "จำนวนที่นั่ง",
      colActions: "การจัดการ",
      alreadyPool: "เพิ่มไว้แล้ว",
      addButton: "เพิ่ม",
      addSuccess: "เพิ่ม {{account}} เข้า Online Channel แล้ว",
      addConflict: "บัญชีนี้ถูกเพิ่มไว้แล้ว",
      addNotFound: "ไม่พบบัญชีนี้ใน ZPCD mirror",
      candidatesEmptyTitle: "ไม่พบบัญชี",
      candidatesEmptyBody: "ลองค้นหาด้วยชื่อหรือเลขบัญชีอื่น",

      credHelperText:
        'แอป Zoom Server-to-Server OAuth ของบัญชีนี้ต้องมี scope ตามรายการด้านล่างนี้เท่านั้น — ห้ามติ๊ก "Optional" ตอนขอ scope มิฉะนั้นจะโดน 403 ทุกครั้งที่เรียก',
      credScopesTitle: "Scope ที่ต้องติ๊กตอนสร้าง Server-to-Server OAuth app",
      credScopeCopyLabel: "คัดลอก {{scope}}",
      credScopeGroupRead: "อ่านข้อมูล — ใช้ตั้งแต่วันนี้",
      credScopeGroupWrite: "เขียน — สำหรับระบบถอด license ภายหลัง",
      credAccountNameLabel: "ชื่อบัญชี",
      credAccountNumberLabel: "เลขบัญชี",
      credZoomAccountIdLabel: "Zoom Account ID",
      credClientIdLabel: "Client ID",
      credClientSecretLabel: "Client Secret",
      credSecretNote: "เข้ารหัสตอนบันทึกแล้ว จะไม่แสดงอีกหลังจากนี้",
      credSubmitButton: "เพิ่มบัญชี",
      credSuccess: "เพิ่ม {{account}} เป็นบัญชี standalone แล้ว",
      credError: "เพิ่มบัญชีไม่สำเร็จ",

      existingTitle: "บัญชีปัจจุบัน",
      colEnabled: "สถานะ",
      enabledOn: "เปิดใช้งาน",
      enabledOff: "ปิดใช้งาน (แช่แข็ง)",
      enableButton: "เปิดใช้งาน",
      disableButton: "ปิดใช้งาน",
      enableDialogTitle: "เปิดใช้งานบัญชีนี้?",
      disableDialogTitle: "ปิดใช้งานบัญชีนี้?",
      enableDialogBody: "{{account}} จะกลับมาถูก sweep และดูแลตามปกติ",
      disableDialogBody:
        '{{account}} จะไม่ถูก sweep อีก — สมาชิกภาพและรอบบริการทั้งหมดจะถูก "แช่แข็ง" ไว้ตามเดิม ' +
        "ไม่ใช่การลบข้อมูล กด เปิดใช้งาน เพื่อกลับมาดูแลต่อได้ทุกเมื่อ",
      enableSuccess: "เปิดใช้งาน {{account}} แล้ว",
      disableSuccess: "ปิดใช้งาน {{account}} แล้ว",
      // rev 7 (21/7): ลบบัญชีออกจาก pool ทั้งหมด — ดู RemovePoolAccountDialog.tsx
      removeButton: "ลบออก",
      removeDialogTitle: "ลบบัญชีนี้ออก?",
      removeDialogBody:
        "{{account}} จะไม่ถูก sweep ตรวจสอบอีกต่อไป แถวสมาชิกภาพ Zoom ที่เคยสังเกตไว้จะถูกลบ ส่วนรอบบริการลูกค้า " +
        "(service periods) และประวัติ audit ของบัญชีนี้จะยังเก็บไว้เหมือนเดิม การกระทำนี้ยกเลิกจากหน้านี้ไม่ได้",
      removeSuccess:
        "ลบ {{account}} ออกจาก Online Channel แล้ว (เคลียร์ข้อมูล member ที่เคยเห็น {{members}} ราย)",
      removeError: "ลบบัญชีออกไม่สำเร็จ",
      existingEmptyTitle: "ยังไม่มีบัญชี",
      existingEmptyBody: "ค้นหาและเพิ่มบัญชีด้านบนเพื่อเริ่มต้น",
      standalone: {
        manageButton: "จัดการ",
        title: "{{name}} — บัญชี standalone",
        testTitle: "ทดสอบ credential ของ Zoom",
        testHint:
          "ตรวจ credential (Server-to-Server) ที่เก็บไว้กับ Zoom ตอนนี้เลย (ขอ token + อ่าน 1 ครั้ง) — " +
          "ใช้เมื่อเพิ่ง rotate secret หรือ sweep ของบัญชีนี้เริ่มล้ม",
        testButton: "ทดสอบการเชื่อมต่อ",
        testOk: "ยืนยันเมื่อ {{when}}",
        acctInfoTitle: "ประเภทบัญชี & จำนวนที่นั่ง",
        acctInfoHint:
          "บัญชี standalone อ่านแพลนหรือจำนวนที่นั่งที่ซื้อจาก Zoom เองไม่ได้ — กรอกเอง หน้าบัญชีและหน้าภาพรวมจะใช้ค่านี้แทนการโชว์ '—'",
        acctTypeLabel: "ประเภทบัญชี",
        acctTypeNotSet: "ยังไม่ระบุ",
        seatsLabel: "จำนวนที่นั่ง",
        seatsInvalid: "จำนวนที่นั่งต้องเป็นจำนวนเต็มมากกว่า 0",
        acctInfoSaveLabel: "บันทึกประเภทบัญชีและจำนวนที่นั่ง",
        acctInfoClear: "ล้างค่า",
        acctInfoClearLabel: "ล้างประเภทบัญชีและจำนวนที่นั่ง",
        subPeriodTitle: "ช่วง subscription ของ Zoom",
        subPeriodHint:
          "บัญชี standalone อ่าน subscription ของตัวเองจาก Zoom ไม่ได้ — กรอกวันเริ่มและวันหมดเอง (ปีละครั้งตอนต่ออายุ) " +
          "การ์ด 'ขายเกินที่ Zoom ส่งมอบได้' บน dashboard ใช้ค่านี้",
        subEndClear: "ล้างค่า",
      },

      operatorsTitle: "สิทธิ์ Online Channel operator",
      operatorsSubtitle:
        "Owner จะอยู่ในลิสต์นี้เสมอและแก้ไขตรงนี้ไม่ได้ — Owner และ Admin แก้ไข/ถอนสิทธิ์ Admin หรือ Viewer ได้",
      operatorsEmptyTitle: "ยังไม่มี operator",
      operatorsEmptyBody: "ค้นหาผู้ใช้งานในระบบด้านล่างเพื่อให้สิทธิ์เข้าถึงโมดูล Online Channel",
      colOperatorEmail: "อีเมล",
      colRole: "สิทธิ์",
      colGrantedBy: "ให้สิทธิ์โดย",
      colGrantedAt: "วันที่ให้สิทธิ์",
      ownerBadge: "Owner",
      candidateOwnerNote: "เป็น Owner อยู่แล้ว มีสิทธิ์เต็มโดยอัตโนมัติ",
      candidateAlreadyOperator: "เป็น operator อยู่แล้ว",
      userSearchLabel: "ค้นหาผู้ใช้งานในระบบด้วยอีเมล",
      userSearchPlaceholder: "name@1-to-all.com",
      userSearchHint: "พิมพ์อย่างน้อย 2 ตัวอักษร",
      grantSuccess: "เพิ่มสิทธิ์ {{email}} แล้ว",
      revokeButton: "ถอนสิทธิ์",
      revokeDialogTitle: "ถอนสิทธิ์ operator?",
      revokeDialogBody: "{{email}} จะไม่สามารถเข้าถึงโมดูล Online Channel ได้อีก",
      revokeSuccess: "ถอนสิทธิ์ {{email}} แล้ว",

      // Modal "เปลี่ยนสิทธิ์" (30/7) — POST /operators ซ้ำด้วยสิทธิ์ใหม่ (endpoint เป็น upsert อยู่แล้ว)
      // ซ่อนที่แถว Owner (ไม่มี row ให้แก้) และแถวของตัวเอง (server จะปฏิเสธการแก้สิทธิ์ตัวเองด้วย 422)
      changeRoleButton: "เปลี่ยนสิทธิ์",
      changeRoleModalTitle: "เปลี่ยนสิทธิ์ — {{email}}",
      changeRoleCurrentRoleLabel: "สิทธิ์ปัจจุบัน",
      changeRoleUnchangedHint: "เลือกสิทธิ์อื่นเพื่อเปิดปุ่มบันทึก",
      changeRoleSubmitButton: "บันทึก",
      changeRoleSuccess: "อัปเดตสิทธิ์ของ {{email}} แล้ว",

      // Modal "เพิ่ม User" (แก้ flow 21/7) — แทนที่ส่วน search+Select ที่เคยโชว์ตลอดเวลา
      addUserButton: "เพิ่ม User",
      addUserModalTitle: "เพิ่มผู้ใช้งาน",
      addUserRoleStepTitle: "เลือกสิทธิ์",
      addUserRoleAdminDesc: "ทำได้ทุกอย่างเหมือน Owner ยกเว้นการแก้ไขสิทธิ์ของ Owner",
      // 30/7: gate เอา dashboard ออกจากสิทธิ์ Viewer แล้ว — คำเดิม ("...ภาพรวม บัญชี และผู้ใช้งาน")
      // สัญญาแท็บที่สิทธิ์นี้เปิดไม่ได้อีกต่อไป
      addUserRoleViewerDesc: "ดูอย่างเดียว — บัญชีและผู้ใช้งาน",
      addUserSubmitButton: "เพิ่ม",
    },

    accounts: {
      title: "บัญชี",
      subtitle: "ภาพรวมบัญชีทั้งหมด พร้อมข้อมูลการใช้งานจาก Zoom",
      colName: "ชื่อบัญชี",
      colNumber: "เลขบัญชี",
      colAccountType: "ประเภทบัญชี",
      colSeats: "ที่นั่ง",
      colSubscriptionStart: "วันเริ่มสมาชิก (Zoom)",
      colSubscriptionEnd: "วันสิ้นสุดสมาชิก (Zoom)",
      // rev 9 (21/7): เปลี่ยนชื่อจาก "มี license" — คอลัมน์นี้นับแถว membership ที่ assign license
      // ออกจาก pool (user_type=2) ชื่อเดิมซ้ำความหมายกับคอลัมน์ License ในหน้า Pool Users
      colAssignedMembers: "Assigned แล้ว",
      // rev 10 (22/7): "สมาชิก" (Members) หายไป — คอลัมน์นี้แทนที่ = Seats ลบ Assigned ติดลบได้
      // (pool ที่ oversold) เซลล์จะขึ้น warn tone ตอนติดลบ
      colUnassigned: "ยังไม่ assign",
      // rev 9 (21/7): Assigned ÷ Seats เป็นเปอร์เซ็นต์จำนวนเต็ม — "—" เมื่อ Seats เป็น null/0
      colUtilization: "อัตราการใช้งาน",
      emptyTitle: "ยังไม่มีบัญชี",
      emptyBody: "ไปที่หน้าตั้งค่าเพื่อเพิ่มบัญชีแรก",
      // rev 8 — "Sync now" (owner/admin only, ข้าง chip "Last Update").
      syncNowButton: "ซิงค์ตอนนี้",
      // rev 17c (23/7, feedback "Sync now") — ปุ่มนี้ติดตามรอบที่ enqueue จนกว่าจะเห็นผลจริง
      // (useRunPoolSweep, features/pool/hooks.ts) แทนที่จะขึ้น toast "เริ่มแล้ว" ครั้งเดียวจบ
      syncRunning: "กำลังซิงค์…",
      syncComplete: "ซิงค์เสร็จแล้ว",
      syncPaused: "อยู่ช่วงพัก 02:00–08:00 — รอบนี้จะถูกข้าม",
      syncTimeout: "ซิงค์ยังไม่จบ — ดูป้าย Last Update อีกครั้งภายหลัง",
      syncAlreadyRunning: "มีการซิงค์กำลังทำงานอยู่แล้ว",
      autoSyncNote: "ระบบ sync อัตโนมัติทุก 5 นาที",
    },

    users: {
      title: "ผู้ใช้งาน",
      subtitle: "ค้นหาผู้ใช้งานและจัดการรอบบริการรายคน",
      searchPlaceholder: "ค้นหาด้วยอีเมล ชื่อบัญชี หรือเลขบัญชี",
      searchLabel: "ค้นหาผู้ใช้งาน",
      colEmail: "อีเมล",
      colAccount: "บัญชี",
      colLicense: "License",
      colServiceStart: "วันเริ่มบริการ",
      colServiceEnd: "วันสิ้นสุดบริการ",
      colRenew: "ต่ออายุ",
      typeBasic: "Basic",
      typeLicensed: "Licensed",
      // 31/7 (คุณใหม่, แถวจริงใน prod jongsert+cr3@gmail.com) — แทนที่ span สีจาง "ไม่พบในบัญชีไหน" เดิม
      // สำหรับผู้ใช้ที่ไม่มี Zoom membership ปัจจุบัน account_id/user_type/role_id มา null พร้อมกันเสมอ
      // (LEFT JOIN เดียว ดูคอมเมนต์หัวไฟล์ PoolUsersPage) — เดิมคือเคส "ถูกนำออก" อยู่แล้ว ไม่ใช่เคสใหม่
      // "ไม่เคย link เลย" แยกต่างหาก — เปลี่ยนชื่อ + เปลี่ยนวิธีแสดงผล ไม่ใช่ state ใหม่ ดูคอมเมนต์คอลัมน์
      // License ของ PoolUsersPage สำหรับเรื่องเต็ม
      removedBadge: "ถูกนำออกแล้ว",
      removedTooltip: "ไม่พบในบัญชีไหนของ Online Channel แล้ว",
      renewYes: "ต่ออายุ",
      renewNo: "ไม่ต่ออายุ",
      renewUndecided: "ยังไม่ตัดสินใจ",
      // r10 22/7: ทางเดียวที่จะเปิด PeriodModal ได้ตอนนี้ — คลิกที่แถวใช้ไม่ได้แล้ว เดิมชื่อ "ตั้งรอบ" เปลี่ยนเป็น
      // "จัดการ" เพราะ modal ทำมากกว่าเรื่องรอบบริการแล้ว (ตัดสินใจต่ออายุตอนสร้างรอบได้เลย)
      // ซ่อนสำหรับ pool-Viewer และซ่อนสำหรับคนที่ไม่ใช่สมาชิก Licensed ปัจจุบัน ยกเว้นแถวนั้นยังมีรอบที่เปิดอยู่
      // (ดูคอมเมนต์ที่ PoolUsersPage เรื่องเงื่อนไขนี้)
      manageButton: "จัดการ",
      // rev 9 (21/7): ตัวกรอง License (Select) เหนือตาราง — ค่าเริ่มต้น Licensed สะท้อนใน ?license=
      filterLicenseLabel: "ตัวกรอง License",
      filterAllOption: "ทั้งหมด",
      // r12 22/7 (feedback คุณใหม่, screenshot production): กรองฝั่ง client จาก "ทั้งหมด" อีกที — เงื่อนไขจริง
      // ดูที่ hooks.ts's poolUserNeedsReview (มีรอบบริการเปิดอยู่ แต่ฝั่ง Zoom ยังไม่ใช่ Licensed)
      filterNeedsReviewOption: "ต้องตรวจสอบ",
      needsReviewBadge: "ควรได้ license",
      needsReviewTooltip:
        "อยู่ในรอบบริการแต่ฝั่ง Zoom เป็น Basic — ลูกค้าจ่ายแล้วแต่ยังไม่ได้ license ตรวจสอบด่วน",
      emptyTitle: "ไม่พบผู้ใช้งาน",
      emptyBody: "ลองค้นหาด้วยคำอื่น",
      filteredByAccount: "กรองเฉพาะ {{account}}",
      clearAccountFilter: "ล้างตัวกรอง",

      // rev 17b — Manage-every-row + multi-select bulk actions (rev17b-addendum.md).
      unlinkOnly: {
        dialogTitle: "เอาออกจากบัญชี — {{email}}",
        dialogBody:
          "จะเอา {{email}} ออกจากบัญชี Zoom ปัจจุบันทันที (unlink) โดยไม่รอรอบ sweep — ดำเนินการต่อหรือไม่?",
        // F5 (pinned): คำเดียวกับปุ่ม/หัวข้อ dialog ยืนยัน bulk unlink — ห้ามใช้คำพ้องอื่น
        confirmButton: "เอาออกจากบัญชี",
      },
      selectAllLabel: "เลือกทั้งหมดในหน้านี้",
      selectRowLabel: "เลือก {{email}}",
      // rev 17c (23/7, "รกเกินไป"): badge ที่โชว์ตลอดถูกเอาออก — เปลี่ยนเป็น hover tooltip บน
      // checkbox ที่ disabled แทน (cell คอลัมน์เลือกใน PoolUsersPage) — ข้อความ pinned ตรงตัว
      ownerAdminTooltip: "Owner/Admin ไม่สามารถเลือกได้",
      // F1: pinned ทุกคำ verbatim
      openPeriodTooltip: "มีรอบบริการเปิดอยู่ — จัดการรายคนผ่านปุ่มจัดการ",
      // F2: pinned verbatim
      standaloneWarning: "บัญชี standalone ยังไม่เปิดสิทธิ์เขียน — ระบบจะข้ามอย่างปลอดภัย",

      bulk: {
        selectedCount: "เลือกแล้ว {{count}} คน",
        clearSelection: "ล้างการเลือก",
        // F5 (pinned Thai copy — ใช้คำนี้ทุกที่: bar / dialog title / confirm button / results)
        licenseRemoveLabel: "ปลด license",
        licenseRemoveSubtitle: "ผู้ใช้ยังอยู่ในบัญชี — เปลี่ยนเป็น Basic",
        unlinkLabel: "เอาออกจากบัญชี",
        unlinkSubtitle: "หลุดจากบัญชี Zoom นี้ทันที (unlink)",
        // F1 (pinned verbatim)
        dryRunHeadline: "โหมดทดสอบ (dry-run) — ยังไม่มีการเปลี่ยนแปลงจริงที่ Zoom",
        // F3 (pinned verbatim)
        abort409:
          "ข้อมูลรอบ sweep ยังไม่สดพอ — ระบบพักช่วง 02:00–08:00 น. ลองใหม่หลัง 08:00 หรือกด Sync now ก่อน",
        // F4 — จบด้วยช่องว่างเสมอ: เรนเดอร์คู่กับลิงก์ pool.tabs.intents ต่อท้าย ("...ตรวจสอบแท็บ Intent ค้าง")
        partialFailureNote: "บางรายการอาจดำเนินการไปแล้ว — ตรวจสอบแท็บ ",
        confirmTitleLicenseRemove: "ปลด license ผู้ใช้ {{count}} คนตอนนี้เลยหรือไม่?",
        confirmBodyLicenseRemove:
          "จะปลด license ผู้ใช้ที่เลือกทั้งหมดทันที (ยังอยู่ในบัญชี เปลี่ยนเป็น Basic) โดยไม่รอรอบ sweep — คนที่ถูกการ์ดความปลอดภัยหยุดไว้จะขึ้นเป็น 'ข้าม' ไม่มีการเปลี่ยนแปลง",
        confirmTitleUnlink: "เอาผู้ใช้ {{count}} คนออกจากบัญชีตอนนี้เลยหรือไม่?",
        confirmBodyUnlink:
          "จะเอาผู้ใช้ที่เลือกทั้งหมดออกจากบัญชี Zoom ปัจจุบันทันที โดยไม่รอรอบ sweep — คนที่ถูกการ์ดความปลอดภัยหยุดไว้จะขึ้นเป็น 'ข้าม' ไม่ใช่เอาออก",
        emailListLabel: "ผู้ใช้ที่เลือก ({{count}})",
        confirmButtonLicenseRemove: "ปลด license",
        confirmButtonUnlink: "เอาออกจากบัญชี",
        // R1 typed-count gate (LIVE only) — พิมพ์จำนวนผู้ใช้ที่เลือกให้ตรงก่อนปุ่มยืนยันจะปลดล็อก
        typeCountLabel: "ยืนยันโดยพิมพ์จำนวนผู้ใช้ที่เลือก: {{count}}",
        typeCountPlaceholder: "พิมพ์ {{count}}",
        progressLabel: "กำลังดำเนินการ {{from}}–{{to}} จาก {{total}}…",
        resultSummary: "สำเร็จ {{ok}} · ข้าม {{skipped}} · ผิดพลาด {{failed}}",
        showDetailsButton: "ดูผลรายคน",
        hideDetailsButton: "ซ่อนผลรายคน",
      },

      // Bulk action เชิงสร้าง (BulkSetPeriodDialog) — ทะเบียนภาษาแบบ operator ภายใน present tense ไม่มี
      // ค่ะ/นะคะ (ให้เข้าชุดกับ copy ของ bulk เดิม ไม่ใช่เสียงผู้ช่วย) F5: ใช้คำ "รอบบริการ" /
      // "ตั้งรอบบริการ" คำเดียวซ้ำทั้ง bar / title / ปุ่มยืนยัน / ผลลัพธ์
      bulkSetPeriod: {
        barLabel: "ตั้งรอบบริการ",
        barSubtitle: "สร้างรอบบริการให้ผู้ใช้ที่เลือก",
        confirmTitle: "ตั้งรอบบริการให้ผู้ใช้ {{count}} คนหรือไม่?",
        confirmBody:
          "จะสร้างรอบบริการหนึ่งรอบ — ใช้วันที่และการตัดสินใจต่ออายุด้านล่าง — ให้ผู้ใช้ที่เลือกทั้งหมด",
        dateRangeSummary: "{{count}} คน · {{start}} – {{end}}",
        arming: {
          undecided:
            "เมื่อถึงวันสิ้นสุด ระบบจะปลด license ให้อัตโนมัติ (ไม่ unlink) — เป็นค่าเริ่มต้นเมื่อยังไม่ตัดสินใจต่ออายุ",
          renewYes:
            "ตั้งเป็นต่ออายุ — ไม่มีการปลด license อัตโนมัติ ผู้ใช้จะเข้าสู่ขั้นตอนเตือนต่ออายุเมื่อใกล้หมดรอบ",
          expiryLicenseOnly: "เมื่อถึงวันสิ้นสุด ระบบจะปลด license เท่านั้น (ไม่ unlink)",
          expiryGrace: "เมื่อถึงวันสิ้นสุด ระบบจะให้เวลาผ่อนผัน {{days}} วัน แล้วจึง unlink",
          expiryDisassociate: "เมื่อถึงวันสิ้นสุด ระบบจะ unlink ผู้ใช้ทันที",
        },
        confirmButton: "ตั้งรอบบริการ",
        progressLabel: "กำลังตั้งรอบบริการ {{current}} จาก {{total}} คน…",
        partialFailureNote:
          "เซิร์ฟเวอร์หยุดตอบกลาง — บางรอบด้านบนถูกสร้างไปแล้ว ลองใหม่ได้ปลอดภัย ผู้ใช้ที่มีรอบอยู่แล้วจะถูกข้าม",
        createdBadge: "สร้างแล้ว",
        noneCreatedBadge: "ยังไม่ได้สร้าง",
      },
    },

    period: {
      // r10 22/7: ใช้ title เดียวทั้งสองสถานะ (เดิมแยก newTitle/"ตั้งรอบบริการ" กับ editTitle/"จัดการ
      // รอบบริการ") — สถานะยังไม่มีรอบเปิดตอนนี้เป็นฟอร์มเดียวที่ตัดสินใจต่ออายุพร้อมกันเลยด้วย ไม่ใช่แค่วันที่
      // อีกต่อไป คำว่า "รอบบริการ" เลยแคบเกินไปทั้งสองสถานะ
      title: "จัดการ — {{email}}",
      // rev 6 R6: คอลัมน์ Status เดิม (active/pending/inactive ฝั่ง Zoom) ย้ายมาเป็นแถวข้อมูล read-only
      // ตรงนี้แทน — ไม่ใช่ฟิลด์แก้ไข r12 22/7: เปลี่ยนป้ายชื่อ + ข้อความค่าเฉพาะ Pool (ดู
      // ZOOM_STATUS_LABEL_KEY ใน PeriodModal.tsx) — นี่คือสถานะบัญชี Zoom ของลูกค้า ไม่ใช่สถานะรอบบริการของเรา
      // ก่อนหน้านี้สับสนกันได้ง่าย (เคส kotchaphat ที่ "pending")
      startLabel: "วันที่เริ่ม",
      endLabel: "วันที่สิ้นสุด",
      // r12 22/7 (feedback คุณใหม่, screenshot production): เขียนใหม่ — ข้อความเดิมอ่านแล้วเหมือนเปลี่ยนที่อยู่
      saveButton: "บันทึกรอบบริการ",
      createSuccess: "ตั้งรอบบริการให้ {{email}} แล้ว",
      updateSuccess: "แก้ไขรอบบริการแล้ว",
      createConflict: "{{email}} มีรอบบริการที่เปิดอยู่แล้ว",

      renewSectionTitle: "การตัดสินใจต่ออายุ",
      renewSectionHint:
        'ค่าเริ่มต้นคือ "ยังไม่ตัดสินใจ" — ถ้าไม่ตั้งค่า ระบบจะปลด license เมื่อหมดรอบโดยไม่ unlink',
      renewYesLabel: "ต่ออายุ (Yes)",
      renewNoLabel: "ไม่ต่ออายุ (No)",
      renewUndecidedLabel: "ยังไม่ตัดสินใจ",

      renewNewDatesTitle: "รอบบริการใหม่",
      renewNewDatesHint: 'เลือก "ต่ออายุ" แล้วต้องระบุวันที่ของรอบใหม่ก่อนบันทึก',
      renewSubmit: "ยืนยันต่ออายุ",
      renewSuccess: "ต่ออายุ {{email}} เรียบร้อย — ปิดรอบเดิมและเปิดรอบใหม่แล้ว",

      nextRoundTitle: "รอบบริการถัดไป",
      nextRoundHint:
        "เริ่ม {{date}} — วันถัดจากวันจบรอบนี้ ระบบจะเปลี่ยนไปรอบใหม่ให้เองเมื่อถึงวันนั้น ระหว่างนี้หน้าจอยังแสดงรอบปัจจุบัน",
      nextEndLabel: "วันจบรอบถัดไป",
      nextRoundPlanned: "รอบถัดไป: {{start}} → {{end}}",

      expiryActionLabel: "เมื่อหมดรอบ ให้ทำ",
      actionLicenseOnly: "ปลด license เท่านั้น (ไม่ unlink)",
      actionGrace: "ให้เวลาผ่อนผันก่อน unlink",
      actionDisassociate: "Unlink ทันที",
      graceDaysLabel: "จำนวนวันผ่อนผัน",
      graceDaysHint: "ต้องมากกว่า 0 วัน",
      saveDecisionButton: "บันทึกการตัดสินใจ",
      decisionSuccess: "บันทึกการตัดสินใจต่ออายุแล้ว",

      closeTitle: "ปิดรอบบริการ",
      closeReasonLabel: "เหตุผลที่ปิดรอบ",
      closeReasonPlaceholder: "ระบุเหตุผล — จำเป็นต้องกรอก",
      closeSubmit: "ปิดรอบบริการ",
      closeSuccess: "ปิดรอบบริการของ {{email}} แล้ว",

      historyButton: "ดูประวัติ",
      historyTitle: "ประวัติ — {{email}}",
      historyPeriodsTitle: "รอบบริการ",
      historyAuditTitle: "ประวัติการทำรายการ",
      historyEmpty: "ยังไม่มีประวัติ",
      historyPeriodClosed: "ปิดแล้ว — {{reason}}",
      historyPeriodOpen: "รอบปัจจุบัน",

      validation: {
        graceDaysRequired: "กรุณาระบุจำนวนวันผ่อนผัน",
        graceDaysPositive: "จำนวนวันผ่อนผันต้องมากกว่า 0",
        expiryActionRequired: "กรุณาเลือกการดำเนินการเมื่อหมดรอบ",
        endAfterStart: "วันที่สิ้นสุดต้องอยู่หลังวันที่เริ่ม",
        reasonRequired: "กรุณาระบุเหตุผล",
        nextEndRequired: "กรุณาระบุวันจบของรอบบริการถัดไป",
        nextEndAfterStart: "วันจบรอบถัดไปต้องอยู่หลังวันเริ่มรอบถัดไป",
      },

      force: {
        sectionTitle: "บังคับดำเนินการทันที (ข้าม sweep)",
        sectionHint: "ดำเนินการทันทีโดยไม่รอรอบ sweep ปกติ — ตรวจสอบให้ดีก่อนกดยืนยัน",
        licenseRemoveButton: "Force ปลดตอนนี้",
        unlinkButton: "Force unlink ตอนนี้",
        licenseRemoveDialogTitle: "บังคับปลด license ตอนนี้เลยหรือไม่?",
        licenseRemoveDialogBody:
          "จะปลด license ของ {{email}} ทันที โดยไม่รอรอบ sweep — ดำเนินการต่อหรือไม่?",
        unlinkDialogTitle: "บังคับ unlink ตอนนี้เลยหรือไม่?",
        unlinkDialogBody:
          "จะ unlink {{email}} ออกจากบัญชีทันที โดยไม่รอรอบ sweep — ดำเนินการต่อหรือไม่?",
        // R1 late ruling (rev17b addendum) — ONE shared body, used by BOTH BulkForceDialog and
        // UnlinkOnlyDialog whenever isLive !== true (off/dry-run/unknown): swaps out for the live-danger
        // sentence so a confirm ceremony never claims "ทันที" while the system genuinely cannot write.
        // Reworded rev 17c (23/7) — โหมด Dry-run ของ UI เองถูกเอาออก (PoolSystemPage) คำเดิม
        // "โหมดทดสอบ (dry-run)" เลยไม่ตรงกับตัวเลือกที่มีจริงอีกต่อไป เปลี่ยนเป็นบอกตรงๆ ว่าระบบปิดอยู่
        testModeBody: "ระบบถอด license ยังปิดอยู่ — การกดนี้จะไม่มีผลจริง",
        // R1 fail-safe (adversarial review) — แสดงตอน isLive ยัง UNKNOWN (query system-state กำลังโหลด
        // หรือ error) ทั้ง body แบบ danger และคำว่า "ระบบปิดอยู่" ยังไม่จริงในจังหวะนี้ จึงแสดงบรรทัดกลางๆ นี้
        // และปิดปุ่มยืนยันไว้ก่อน สถานะที่ไม่รู้ต้องไม่เปิดให้เขียนแบบไม่มี gate และต้องไม่ยืนยันว่าระบบปิด
        checkingWriteMode: "กำลังตรวจสอบสถานะระบบ…",
        resultTitle: "ผลการดำเนินการ",
        dryRunBadge: "โหมดทดลอง (dry-run)",
        liveBadge: "ดำเนินการจริงแล้ว",
        noWriteBadge: "ยังไม่มีการส่งคำสั่ง",
        mirrorPendingNote:
          "ผู้ใช้นี้ยังไม่อยู่ใน mirror ประจำวัน (user ใหม่จะเข้าหลัง sync ~07:05) — กด force ตอนนี้ระบบจะข้ามให้แบบปลอดภัย ลองใหม่หลัง sync เช้าค่ะ",
        noActions: "ไม่มีการดำเนินการที่บันทึกไว้",
        outcome: {
          skipMirrorNotReady:
            "หยุดไว้ก่อน — ผู้ใช้นี้ยังไม่มีข้อมูลสดใน mirror ประจำวัน (user ใหม่จะเข้าหลัง sync เช้า ~07:05) ลองใหม่หลังจากนั้นค่ะ",
          okLicenseRemoved: "ปลด license แล้ว — ผู้ใช้เป็น Basic แล้ว",
          okUnlinked: "unlink แล้ว — ผู้ใช้ถูกนำออกจากบัญชีนี้แล้ว",
          dryRunLicenseRemoved: "โหมดทดลอง — จำลองการปลด license ยังไม่ได้ส่งคำสั่งจริงไป Zoom",
          dryRunUnlinked: "โหมดทดลอง — จำลองการ unlink ยังไม่ได้ส่งคำสั่งจริงไป Zoom",
          alreadyBasic: "ผู้ใช้เป็น Basic อยู่แล้ว — ไม่มี license ให้ปลด",
          abort404: "หยุดการทำงาน — ไม่พบผู้ใช้นี้ในบัญชีแล้ว",
          abortGuard: "การ์ดความปลอดภัยหยุดไว้ — ยังไม่ได้ส่งคำสั่งไป Zoom",
          abortGetFailed: "หยุดการทำงาน — อ่านข้อมูลผู้ใช้จาก Zoom ไม่สำเร็จ ลองใหม่อีกครั้ง",
          failedWrite: "Zoom ปฏิเสธคำสั่ง — ดูรายละเอียดใน audit log",
          skipGuard: "การ์ดความปลอดภัยข้ามไว้ — ยังไม่ได้ส่งคำสั่งไป Zoom",
          // rev 17b — bulk-force เท่านั้น: เจอ period ที่เปิดอยู่ระหว่างเดินทางแบบ membership-keyed
          skipHasOpenPeriod:
            "ข้ามไว้ — ผู้ใช้นี้มีรอบบริการเปิดอยู่ ให้จัดการผ่านปุ่มจัดการรายคนแทน",
          // R1 late ruling — เขียนสำเร็จแล้วแต่ read-back verification (ทันที + retry ~3s) ยังไม่เห็น
          // สถานะเปลี่ยน — รอ sweep รอบถัดไปยืนยันปิดจบให้
          acceptedPendingSweep: "Zoom รับคำสั่งแล้ว — รอ sweep ยืนยันขั้นสุดท้าย",
          // Set-period-only (BulkSetPeriodDialog สังเคราะห์ฝั่ง client ไม่ได้มาจาก force pipeline)
          okCreated: "ตั้งรอบบริการแล้ว",
          failedCreate: "ตั้งรอบบริการไม่สำเร็จ",
        },
      },
    },

    intents: {
      title: "Intent ค้าง",
      subtitle: "การเขียนสองขั้นตอนที่ sweep ยังไม่ได้ปิดจบ — ส่วนใหญ่เกิดจากระบบ crash",
      colTs: "เวลา",
      colAction: "การดำเนินการ",
      colEmail: "อีเมล",
      colTrigger: "ต้นเหตุ",
      colStatus: "สถานะ",
      actionLicenseRemove: "ปลด license",
      actionUserUnlink: "Unlink ผู้ใช้",
      staleWarning: "เกิน 10 นาที — crash?",
      pendingLabel: "รอดำเนินการ",
      resolveButton: "แก้ไข",
      emptyTitle: "ไม่มี intent ค้าง",
      emptyBody: "ทุก intent ที่ sweep เริ่มไว้มีการเขียนปิดจบครบแล้ว",
      openCountAria: "ค้างอยู่ {{count}} รายการ",

      resolveTitle: "แก้ไข intent ค้าง — {{email}}",
      resolveExplanation: "ผล Zoom ไม่รู้จริง — เทียบกับ sweep ก่อนตัดสินใจ",
      noteLabel: "หมายเหตุ (จำเป็นต้องกรอก)",
      notePlaceholder: "ตรวจอะไรไปบ้าง และพบว่าอย่างไร?",
      successButton: "Zoom ทำไปแล้วจริง (success)",
      failedButton: "Zoom ไม่ได้ทำ (failed)",
      confirmSuccessTitle: "ยืนยันว่า Zoom ทำสำเร็จจริง?",
      confirmSuccessBody: "จะบันทึกว่าการดำเนินการของ {{email}} สำเร็จจริง — sweep จะไม่สั่งซ้ำอีก",
      confirmFailedTitle: "ยืนยันว่า Zoom ยังไม่ได้ทำ?",
      confirmFailedBody:
        "จะบันทึกว่าการดำเนินการของ {{email}} ยังไม่สำเร็จ — sweep จะลองใหม่รอบถัดไป",
      resolveSuccessToastTitle: "แก้ไข intent เรียบร้อย",

      validation: {
        noteRequired: "กรุณาระบุหมายเหตุ",
        noteTooLong: "หมายเหตุต้องไม่เกิน 500 ตัวอักษร",
      },
    },

    dashboard: {
      title: "ภาพรวม",
      // rev 16: อัปเดตให้ครอบคลุมทั้งภาพรวม license (เนื้อหาใหม่ที่ขึ้นก่อน) และการ์ดเทียบความไม่ตรงกัน
      // (เดิมเป็นหัวข้อเดียวที่พูดถึงแค่ "ไม่ตรงกัน" ทั้งที่ตอนนี้เนื้อหาแรกไม่ใช่เรื่องนั้นแล้ว)
      subtitle:
        "ภาพรวมการใช้ license ของ Online Channel พร้อมจุดที่ระบบเรากับความจริงฝั่ง Zoom ไม่ตรงกัน",
      // rev 16 (23/7, feedback คุณใหม่): เปลี่ยนชื่อจาก "Zoom มี · เราไม่มี" / "เรามี · Zoom ไม่มี" —
      // อ่านแล้วเหมือนปริศนา ไม่รู้ความหมายทันที การ์ดเดิม ฟิลด์เดิม เปลี่ยนแค่ชื่อให้เข้าใจง่ายขึ้น
      // ("ปลด license" คือคำที่ระบบนี้ใช้เฉพาะการกระทำทำลาย/ยึดคืน license — ใช้เป็นชื่อการ์ดข้อมูลเฉยๆ
      // จะสื่อผิดว่าเป็นปุ่มกด ทั้งที่จริงเป็นแค่สถานะ "มี license แต่ไม่มีรอบขาย" ตามคำอธิบายใต้ชื่อ)
      card1Title: "มี license แต่ไม่ได้ขาย",
      card1Subtitle:
        "Zoom โชว์ว่ามี license อยู่ แต่เราไม่มีรอบบริการเปิดอยู่ให้ — อาจเป็น license ที่ยังไม่ได้เก็บเงิน หรือให้ใช้ฟรี",
      card2Title: "ขายแล้ว แต่ไม่ได้ license",
      card2Subtitle:
        "มีรอบบริการเปิดอยู่ แต่ Zoom ยังไม่โชว์ว่าลูกค้าได้ license — จ่ายเงินแล้วแต่ยังใช้ไม่ได้",
      colEmail: "อีเมล",
      colAccount: "บัญชี",
      viewInUsers: "ดูในหน้าผู้ใช้งาน",
      emptyTitle: "ไม่มีรายการ",
      card1EmptyBody: "ไม่มี license ที่ไร้รอบบริการในตอนนี้",
      card2EmptyBody: "ไม่มีรอบบริการที่ไร้ license ในตอนนี้",

      // rev 16 — ภาพรวมใหม่ด้านบนสุดของหน้า (คำนวณฝั่ง client จาก GET /pool/accounts — ดู poolAccountStats.ts)
      overview: {
        title: "ภาพรวม License",
        subtitle: "บัญชีที่ตั้งค่าไว้ทั้งหมด — มี license รวมเท่าไหร่ ใช้ไปเท่าไหร่ เหลือเท่าไหร่",
        tileAccounts: "จำนวนบัญชี",
        tileSeats: "License ที่จ่ายแล้วทั้งหมด",
        tileAssigned: "Assigned แล้ว",
        tileUnassigned: "ยังไม่ assign",
        tileUtilization: "อัตราการใช้งาน",
        breakdownTitle: "แยกตามประเภทบัญชี",
        colAccountType: "ประเภทบัญชี",
        colAccounts: "จำนวนบัญชี",
        colSeats: "License ที่จ่ายแล้ว",
        colAssigned: "Assigned แล้ว",
        colUnassigned: "ยังไม่ assign",
        colUtilization: "อัตราการใช้งาน",
        // บัญชี standalone ที่เพิ่มก่อนจะกรอก Account type/Seats (Settings → จัดการ) — ที่นั่งของบัญชีนี้
        // จะไม่ถูกรวมในยอด Seats/Unassigned/Utilization แทนการเดา — กฎ "—" เดียวกับทั้งตาราง
        tierUnknown: "ยังไม่ระบุ",
        // rev 16 แก้ในวันเดียวกัน (จาก adversarial review): โชว์เฉพาะตอนที่บัญชี "ยังไม่ระบุ" มีคน
        // assign จริงอยู่ — นั่นคือจุดที่ทำให้ตัวเลข Total ด้านบนกลายเป็นตัวเลขผสม
        blendedNote:
          "มี {{count}} ที่นั่งที่ assign แล้ว มาจากบัญชีที่ยังไม่ได้กรอกจำนวน Seats — ตัวเลข Unassigned/Utilization ด้านบนนับรวมไปด้วยโดยไม่ได้นับ seats ของบัญชีนั้น กรอก Account type & Seats ที่ Settings เพื่อให้ยอดถูกต้อง",
        emptyTitle: "ยังไม่มีบัญชี",
        emptyBody: "ไปที่หน้าตั้งค่าเพื่อเพิ่มบัญชีแรก",
      },
    },

    system: {
      title: "ควบคุมระบบถอด License",
      subtitle: "เปิด/ปิด และสลับโหมดของงานถอด license อัตโนมัติของ Online Channel",

      stateOff: "ปิด",
      stateLive: "จริง (LIVE)",

      explainOff: "ไม่ทำงานเลย — ระบบจะไม่แตะ license ของลูกค้าเลย",
      explainLive: "ถอด license ลูกค้าจริงผ่าน Zoom — มีผลกับลูกค้าจริง",

      // rev 17c (23/7, คุณใหม่: "ถ้าจะเทส คือเทสจริงด้วย user test") — โหมด Dry-run ถูกเอาออกจาก UI
      // แล้ว เหลือร่องรอยเดียวคือข้อความนี้ เผื่อ server รายงานสถานะ dry_run เดิม (ดู banner ของ
      // PoolSystemPage เอง rev 17c)
      legacyDryRunNote: "สถานะเดิม (dry-run) — เลือกโหมดใหม่",

      updatedBy: "เปลี่ยนล่าสุดโดย {{who}} เมื่อ {{when}}",
      neverUpdated: "ยังไม่เคยมีการเปลี่ยนค่า",
      settingsSourceNote: "ยังไม่เคยตั้งค่า — ใช้ค่าตั้งต้น",
      hardDisabledNote: "ถูกล็อกปิดจากฝั่ง server (.env break-glass) — แก้ไขได้จาก server เท่านั้น",

      switchToOff: "สลับเป็นปิด",
      switchToLive: "สลับเป็น LIVE",

      confirmOffTitle: "ปิดระบบถอด license?",
      confirmOffBody: "ระบบจะหยุดถอด license ลูกค้าทั้งหมดทันที จนกว่าจะเปิดใหม่",

      liveDialogTitle: "ยืนยันเปิดโหมด LIVE",
      liveDialogWarning:
        "โหมดนี้จะถอด license ของลูกค้าจริงผ่าน Zoom — การถอดที่ทำไปแล้วย้อนกลับไม่ได้",
      liveTypeToConfirmLabel: 'พิมพ์ "LIVE" (ตัวพิมพ์ใหญ่ทั้งหมด) เพื่อยืนยัน',
      liveTypeToConfirmPlaceholder: "LIVE",
      liveConfirmButton: "เปิดโหมด LIVE",

      switchSuccess: "เปลี่ยนสถานะเป็น {{state}} แล้ว",
    },

    audit: {
      title: "บันทึกการใช้งาน",
      subtitle: "ทุกการเขียนและสิ่งที่ sweep สังเกตเห็นในโมดูล Online Channel",

      filterEmailLabel: "อีเมลลูกค้า",
      filterEmailPlaceholder: "name@example.com",
      filterActorLabel: "อีเมลผู้ทำรายการ",
      filterActorPlaceholder: "อีเมลแบบตรง…",
      filterActionLabel: "การดำเนินการ",
      allActions: "ทั้งหมด",

      colTime: "เวลา",
      colActor: "ใครทำ",
      colAction: "ทำอะไร",
      colTarget: "เป้าหมาย",
      colTrigger: "ต้นเหตุ",
      colDetail: "รายละเอียด",
      colActions: "การกระทำ",
      moreLines: "อีก {{count}} รายการ",
      viewDetails: "ดูรายละเอียด",

      emptyTitle: "ไม่มีบันทึก",
      emptyBody: "ไม่มีรายการที่ตรงกับตัวกรอง",

      detailModalTitle: "รายการที่ #{{id}}",
      detailTargetEmail: "อีเมลเป้าหมาย",
      detailTargetEmailOld: "อีเมลเดิม",
      detailAccount: "บัญชี",
      detailPeriodId: "รหัสรอบบริการ",
      detailIntentAt: "เขียน intent เมื่อ",
      detailResult: "ผลลัพธ์",
      pendingResult: "รอผล",
      detailHttpStatus: "HTTP status",
      detailZoomCode: "Zoom code",
      detailCompletedAt: "เสร็จสิ้นเมื่อ",
      detailIp: "IP",
      detailRequestId: "Request ID",
      detailRawJson: "รายละเอียดดิบ (JSON)",

      // แผนที่ action → คำอธิบาย (poolAuditFormat.ts's AUDIT_ACTION_LABEL_KEY) — ดูที่มาของลิสต์นี้ในไฟล์นั้น
      actionPoolAdd: "เพิ่มบัญชี",
      actionPoolEnable: "เปิดใช้งานบัญชี",
      actionPoolDisable: "ปิดใช้งานบัญชี",
      actionAccountRemove: "ลบบัญชี",
      actionAccountSubscriptionPeriod: "ตั้งช่วง subscription ของ Zoom (standalone)",
      actionAccountManualInfo: "ตั้งประเภทบัญชี / จำนวนที่นั่ง (standalone)",
      actionCredentialTest: "ทดสอบ credential ของ Zoom (standalone)",
      actionObservedConflict: "Sweep พบ: อีเมลเดียวอยู่มากกว่า 1 บัญชี",
      actionSweepManualTrigger: "สั่งซิงค์ด้วยตนเอง",
      actionPeriodCreate: "สร้างรอบบริการ",
      actionPeriodUpdate: "แก้ไขรอบบริการ",
      actionPeriodClose: "ปิดรอบบริการ",
      actionRenewSet: "ตั้งการตัดสินใจต่ออายุ",
      actionOperatorGrant: "ให้สิทธิ์ Online Channel",
      actionOperatorRevoke: "ถอนสิทธิ์ Online Channel",
      actionSystemStateChange: "เปลี่ยนสถานะระบบถอด license",
      actionIntentResolve: "แก้ไข intent ค้าง",
      actionForceLicenseRemove: "บังคับปลด license",
      actionForceUnlink: "บังคับ unlink",
      actionForceBulk: "บังคับทำรายการแบบกลุ่ม",
      actionLicenseRemove: "ปลด license (งานหมดอายุ)",
      actionUserUnlink: "Unlink ผู้ใช้ (งานหมดอายุ)",
      actionObservedMoved: "Sweep พบ: ย้ายบัญชี",
      actionObservedJoined: "Sweep พบ: เข้าร่วมใหม่",
      actionObservedLeftEstate: "Sweep พบ: ออกจากระบบ Zoom",
      actionObservedLicenseRemoved: "Sweep พบ: license ถูกปลด",
      actionObservedLicenseGranted: "Sweep พบ: ได้รับ license",
      actionObservedRenamed: "Sweep พบ: เปลี่ยนอีเมล",
      actionObservedRecreated: "Sweep พบ: สร้างผู้ใช้ใหม่ (user id เปลี่ยน)",
      actionObservedRenameConflict: "Sweep พบ: เปลี่ยนอีเมลชนกัน",
      actionObservedBlankEmail: "Sweep พบ: อีเมลว่างใน roster",
      // 30/7 — งาน snapshot รายวัน (23:00) ที่อยู่เบื้องหลังแท็บ Reports; actor "system"
      actionSnapshotDaily: "บันทึก snapshot ประจำวัน",
    },

    // แท็บ Reports ("ประวัติบัญชี Online Channel", 30/7) — snapshot รายวันของทั้งระบบ ใช้ประตูเดียวกับ
    // Dashboard (`_manage` เท่านั้น) และสูตรคำนวณเดียวกัน (poolAccountStats.ts) เพื่อให้ตัวเลขวันเก่า
    // อ่านแบบเดียวกับวันนี้
    reports: {
      title: "ประวัติบัญชี Online Channel",
      subtitle: "Snapshot รายวันของ Online Channel ทั้งหมด — เลือกวันเพื่อดูตัวเลขของวันนั้น",
      period: "ช่วงเวลา",
      deltaTitle: "License ที่ใช้งาน — เพิ่ม/ลดรายวัน",
      deltaUnit: "เปลี่ยนแปลง",
      deltaNoBaseline:
        "“—” = ไม่มี snapshot ของวันก่อนหน้าให้เทียบ (วันแรกของช่วงที่เลือก หรือคืนที่ระบบไม่ได้เก็บ snapshot)",
      levelTitle: "License ที่ใช้งานในแต่ละวัน",
      levelUnit: "ที่ใช้งาน",
      colDate: "วันที่",
      colAccounts: "จำนวนบัญชี",
      // ใช้คำเดียวกับ pool.dashboard.overview.tileSeats สำหรับตัวเลขนี้
      colSeats: "License ที่จ่ายแล้วทั้งหมด",
      colAssigned: "Assigned แล้ว",
      colUnassigned: "ยังไม่ assign",
      colUtilization: "อัตราการใช้งาน",
      emptyTitle: "ยังไม่มี snapshot",
      emptyBody: "ระบบบันทึก snapshot ทุกวันตอน 23:00 — วันแรกจะขึ้นหลังคืนนี้",

      backToList: "กลับไปหน้าประวัติบัญชี",
      capturedAt: "บันทึกเมื่อ {{when}}",
      dayNotFoundTitle: "ไม่มี snapshot สำหรับวันนี้",
      dayNotFoundBody:
        "ไม่มีการบันทึก snapshot รายวันสำหรับวันที่นี้ — อาจเป็นช่วงก่อนมีแท็บ Reports หรือคืนนั้น sweep ข้ามไป",
      accountsTitle: "บัญชีของวันนี้",
      colAccount: "บัญชี",
      colType: "ประเภท",
    },
  },
} as const;

export default th;
